// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:24:57.180Z
// Property: The Griffin (ID: 6767906449163357)
// Collections: 23 amenities, 16 floorplans (live), 34 photos, 83 POIs, 5 reviews, 3 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "6767906449163357",
  "property_external_id": "5394476",
  "property_zillow_url": "https://www.zillow.com/apartments/brandon-fl/courtney-trace/5Xhz6y/",
  "property_apartments_url": "https://www.apartments.com/the-griffin-brandon-fl/qjr7q0x/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Griffin/data=!4m2!3m1!1s0x0:0x1f40de3cc63d8b7c?sa=X&ved=2ahUKEwiTspjF4bySAxUxgoQIHQ_PN-AQ_BJ6BAgPEAA&hl=en&gl=us",
  "property_linkedin_url": "https://www.linkedin.com/in/trace-s-griffin-mba-cmpe-20797a10",
  "property_hubspot_id": "22307032624",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-griffin",
  "property_name": "The Griffin",
  "property_website_url": "https://www.liveatthegriffin.com",
  "property_domain": "https://www.liveatthegriffin.com/",
  "property_address": "1131 Courtney Trace Dr",
  "property_full_address": "1131 Courtney Trace Dr, Brandon, FL 33511",
  "property_address_1": "1131 Courtney Trace Dr",
  "property_address_2": null,
  "property_address_city": "Brandon",
  "property_address_state": "FL",
  "property_address_zip_full": "33511-4945",
  "property_address_zip": "33511",
  "property_address_country": "US",
  "property_address_county": "Hillsborough County",
  "property_neighborhood_address": "Brandon",
  "property_address_latitude": "27.9196491",
  "property_address_longitude": "-82.3319635",
  "property_email": "griffin@alapts.com",
  "property_phone": "(813) 651-4340",
  "property_call_tracking_phone": "656-220-0965",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Modern Brandon living with room to spread out.</strong> Choose spacious one-, two-, and three-bedroom apartments or townhome-style layouts with elevated finishes, smart home features, and in-home laundry—then explore <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> of The Griffin.</p>",
  "property_long_description": "<p><strong>Modern Brandon living with room to spread out.</strong> At The Griffin, you can choose from spacious one-, two-, and three-bedroom apartments, including townhome-style layouts, then settle into finishes built for everyday ease: granite or quartz countertops, premium black or stainless steel appliances, wood-style flooring, smart home features, generous closets, USB outlets, and an in-home washer and dryer. Select homes add screened patios or balconies, fenced yards, garages, storage, and lake, pool, or wooded views.</p><p>Outside your door, the community keeps the pace relaxed with two resort-inspired pools, sunning decks, two fitness centers, a resident clubhouse, conference rooms, grilling areas, a leash-free bark park, valet trash, and a 24-hour package system. Explore the full <a href=\"/amenities\">amenity collection</a>, compare <a href=\"/floor-plans\">floor plan options</a>, or head out to nearby Brandon Exchange, Topgolf Tampa, Causeway Boulevard dining, I-75, and the Selmon Expressway for smooth access across the Tampa Bay area.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89fa-2cfd-759f-9fda-faeed1d85491.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and palm trees.",
    "public_id": "019e89fa-2cfd-759f-9fda-faeed1d85491",
    "storage_key": "property/6767906449163357/019e89fa-2cfd-759f-9fda-faeed1d85491.webp",
    "width": 3072,
    "height": 2049
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "455",
  "property_year_built": "2008",
  "property_year_renovated": "2024",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.6043956043956",
  "property_admin_fee": "250",
  "property_application_fee": "85",
  "property_fees_deposit_info": "Application Fee $85\nAdministrative Fee $250\nNon-Refundable Pet Fee $350/ pet\nMonthly Pet Rent $30 / pet\nApplication Approval Fee Starting At $350\n",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $350 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $350 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://9147604.onlineleasing.realpage.com/",
  "property_resident_portal_url": "https://thegriffinalm.loftliving.com/login",
  "property_apply_now_url": "https://9147604.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e73d2-4262-75cc-bca5-a36e22190d0b.webp",
  "property_primary_logo_media": {
    "alt_text": "The Griffin logo on a dark background.",
    "public_id": "019e73d2-4262-75cc-bca5-a36e22190d0b",
    "storage_key": "property/6767906449163357/019e73d2-4262-75cc-bca5-a36e22190d0b.webp",
    "width": 3072,
    "height": 1175
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e73d2-8af2-713d-9ba7-0652b5633214.webp",
  "property_secondary_logo_media": {
    "alt_text": "The Griffin Luxury Apartments Florida logo.",
    "public_id": "019e73d2-8af2-713d-9ba7-0652b5633214",
    "storage_key": "property/6767906449163357/019e73d2-8af2-713d-9ba7-0652b5633214.webp",
    "width": 3072,
    "height": 1446
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e73d4-d274-7658-ae38-0fedef22e645.webp",
  "property_icon_media": {
    "alt_text": "Logo with a large G and a horizontal line",
    "public_id": "019e73d4-d274-7658-ae38-0fedef22e645",
    "storage_key": "property/6767906449163357/019e73d4-d274-7658-ae38-0fedef22e645.webp",
    "width": 1902,
    "height": 1900
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e73d4-d274-7658-ae38-0fedef22e645.webp",
  "property_fav_icon_media": {
    "alt_text": "Logo with a large G and a horizontal line",
    "public_id": "019e73d4-d274-7658-ae38-0fedef22e645",
    "storage_key": "property/6767906449163357/019e73d4-d274-7658-ae38-0fedef22e645.webp",
    "width": 1902,
    "height": 1900
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e73d2-444b-74ec-9463-26beb98923d0.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Griffin logo on a black background.",
    "public_id": "019e73d2-444b-74ec-9463-26beb98923d0",
    "storage_key": "property/6767906449163357/019e73d2-444b-74ec-9463-26beb98923d0.webp",
    "width": 3072,
    "height": 1175
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e73d2-4458-779e-8fc8-2018e9bf6ab2.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Griffin logo",
    "public_id": "019e73d2-4458-779e-8fc8-2018e9bf6ab2",
    "storage_key": "property/6767906449163357/019e73d2-4458-779e-8fc8-2018e9bf6ab2.webp",
    "width": 3072,
    "height": 1175
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#90906f",
  "property_secondary_color": "#cda786",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#babeab",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "822 - 1570",
  "property_sqft_min": "822",
  "property_sqft_max": "1570",
  "property_price_range": "1640 - 2137",
  "property_price_min": "1640",
  "property_price_max": "2137",
  "property_available_units": 20,
  "property_facebook_url": "https://www.facebook.com/thegriffinaptsbrandon",
  "property_instagram_url": "https://www.instagram.com/thegriffinapartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJvV0NUjjOwogRfIs9xjzeQB8",
  "property_youtube_url": "https://www.youtube.com/watch?v=YU_mioK8Rok",
  "property_yelp_url": "https://www.yelp.com/biz/the-griffin-brandon",
  "property_tiktok_url": "https://www.tiktok.com/@dindinscapri/video/7433530781492071726",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Everyday convenience, polished up.</strong> At The Griffin, poolside lounging, clubhouse meetups, conference-room calls, and fitness-center sessions are all part of the routine. Add grilling areas, a sundeck, leash-free dog park, valet trash, and a 24-hour package system, and life in Brandon feels easy to keep moving.</p><p>Inside, hard-surface flooring, sleek counters, tile backsplashes, USB outlets, walk-in closets, and included washers and dryers bring the same streamlined comfort home.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans with room to choose.</strong> Explore one-, two-, and three-bedroom apartments in Brandon, plus a townhome-style option with added separation. Inside, look for open kitchens with granite or quartz countertops, stainless steel or premium black appliances, tile backsplashes, in-home washer and dryer sets, and generous closets. Select layouts add screened patios or balconies, fenced yards, garages, storage, and lake, pool, or wooded views.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture life at The Griffin.</strong> Preview bright kitchens with stainless steel appliances, tile backsplashes, and sleek counters; open living spaces with wood-style flooring; and bedrooms with generous closet space. The gallery also captures poolside lounging, grilling areas, a polished clubhouse, fitness center, leash-free dog park, screened patios or balconies, select fenced yards, and calming lake, pool, or wooded views.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Brandon keeps daily plans close and weekends wide open.</strong> From The Griffin, Lake Brandon Shoppes, Lumsden Road dining, and Brandon Exchange are just minutes away, with Topgolf Tampa and the Palm River entertainment corridor nearby for bigger nights out. Add easy access to I-75 and the Selmon Expressway, and Ybor City, downtown Tampa, and open-air time at Paul Sanders Park stay comfortably within reach.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents say The Griffin stands out for service and ease.</strong> Reviews often mention a helpful leasing team, responsive maintenance, well-kept grounds, spacious apartments, and updated features. Add in renovated amenities, monthly community events, and a Brandon location near shopping, dining, and major routes, and the feedback paints a clear picture of everyday convenience. Read more reviews to see what residents appreciate most.</p>",
  "property_neighborhood_blurb": "<p><strong>Brandon puts the everyday within easy reach.</strong> From The Griffin, you can keep routines simple with Lake Brandon Shoppes close by, dinner options clustered around Lumsden Road and Causeway Boulevard, and Brandon Exchange just up the road for shopping, restaurants, and a full afternoon out. When plans call for more energy, Topgolf Tampa and the Palm River entertainment corridor are minutes away.</p><p>Weekends can shift from neighborhood errands to open-air time at Paul Sanders Park, or from a quick coffee run to a night in Ybor City or downtown Tampa via I-75 and the Selmon Expressway. Back home, relaxed community spaces and polished interiors keep the pace balanced—explore the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how The Griffin connects you to Brandon living.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that keep your day moving.</strong> At The Griffin, you can switch from poolside downtime to a fitness-center workout, take a call from the conference room, or meet up in the resident clubhouse without leaving the community. Outdoor grilling areas, a sundeck, a leash-free dog park, valet trash, online resident services, and a 24-hour package system add easy momentum to life in Brandon.</p><p>Inside, your apartment brings the same practical polish with hard-surface flooring, sleek counters, decorative tile backsplash, stainless steel or premium appliance finishes, USB outlets, walk-in closet space, and an included washer and dryer. Select homes offer even more flexibility with garages, storage, fenced yards, first-floor access, and lake, pool, or wooded views. Browse the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see the amenities in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make The Griffin home?</strong> Start your online application for a spacious one-, two-, or three-bedroom apartment with everyday-easy finishes like granite or quartz countertops, wood-style flooring, smart home features, generous closets, and an in-home washer and dryer.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Contact The Griffin leasing team for help with spacious one-, two-, and three-bedroom apartments, townhome-style layouts, modern finishes, and available features like patios, garages, storage, or scenic views. We’re here to make your next step simple.</p>",
  "property_faqs_blurb": "<p><strong>Questions about The Griffin?</strong> Start here for quick answers about the community, leasing, floor plans, finishes, and everyday living in our spacious one-, two-, and three-bedroom apartments, including townhome-style layouts. If you need anything else, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits your day.</strong> The Griffin gives you room to choose, from comfortable one-bedroom apartments to expansive two- and three-bedroom floor plans, plus a two-bedroom townhome-style option with extra separation between living and sleeping spaces. As you compare availability in Brandon, look for details that make daily routines feel polished: open kitchens with granite or quartz countertops, stainless steel or premium black appliances, decorative tile backsplashes, in-home washer and dryer sets, generous closets, and smart, modern finishes.</p><p>Select homes add even more flexibility with screened patios or balconies, fenced yards, garages, storage, and calming lake, pool, or wooded views. Browse the floor plan cards, check current pricing, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your preferred layout in person.</p>",
  "property_gallery_blurb": "<p><strong>See The Griffin in focus.</strong> Browse photos that bring the textures and views into frame: bright kitchens with sleek counters, tile backsplashes, and stainless steel appliances; open living areas with wood-style flooring; and bedrooms with generous closet space. Outside, linger on poolside scenes, sunning decks, and outdoor grilling areas. You’ll also spot polished resident spaces like the clubhouse, fitness center, and leash-free dog park.</p><p>As you scroll, look for the details that shape each layout—screened patios and balconies, select fenced yards, garage options, and calming lake, pool, or wooded views. Then compare <a href=\"/floor-plans\">available floor plans</a>, explore the full <a href=\"/amenities\">amenity collection</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore The Griffin from every angle.</strong> Use the interactive map to find available one-, two-, and three-bedroom apartments, then see how close you are to Brandon shopping, dining, and easy routes across the Tampa Bay area.</p>",
  "property_pets_blurb": "<p><strong>Room for paws, claws, and everyday routines.</strong> At The Griffin, your cat or dog can settle into apartment living with practical comforts all around: hard-surface flooring in select spaces, an in-home washer and dryer, generous closet space for pet gear, and select homes with screened outdoor space or fenced yards.</p><p>Step outside for fresh air at the <a href=\"/amenities\">leash-free bark park</a>, then keep the day moving with nearby options for pet supplies, grooming, and care in Brandon. With a pet policy designed for cats and dogs and no weight limit, The Griffin makes it easier to choose a home that works for the way you and your pet live. Have a specific breed-policy question? <a href=\"/contact-us\">Contact the leasing team</a> before you apply.</p>",
  "property_referafriend_blurb": "<p><strong>Share modern Brandon living.</strong> If you love the spacious layouts, everyday-easy finishes, resort-inspired pools, fitness centers, and relaxed spaces at The Griffin, invite a friend to take a closer look. Send a referral today and help them find their next apartment here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at The Griffin.</strong><br>Log in to pay rent, submit maintenance requests, and manage your account with everyday ease—so you can get back to enjoying spacious Brandon living, smart home features, in-home laundry, and relaxed community spaces.</p>",
  "property_reviews_blurb": "<p><strong>See what living at The Griffin feels like through resident reviews.</strong> Residents often highlight the helpful leasing team, responsive maintenance, well-kept grounds, and a convenient Brandon location close to shopping, dining, and major routes. Many also call out spacious apartments, updated features, and community spaces that make day-to-day living easier.</p><p>From comments like “great place to live” to praise for monthly events, friendly service, and renovated <a href=\"/amenities\">amenities</a>, these reviews offer a real look at the experience here. Browse the ratings below to hear directly from residents and get a better sense of what stands out at The Griffin.</p>",
  "property_created_at": "1752257955866",
  "property_scheduletour_blurb": "<p><strong>See The Griffin for yourself.</strong> Tour spacious one-, two-, and three-bedroom apartments with granite or quartz countertops, wood-style flooring, smart home features, generous closets, and in-home laundry. Then picture the relaxed pace beyond your door, from resort-inspired pools to clubhouse spaces. Schedule your tour today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong><br> The Griffin leasing team will follow up soon. In the meantime, picture modern Brandon living with spacious one-, two-, and three-bedroom layouts, everyday-easy finishes, smart home features, and relaxed community spaces designed to help you settle in and spread out.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through The Griffin before you arrive.</strong> Start with the community virtual tour to get a feel for the shared spaces, then step inside two available 2-bedroom, 2-bath apartment tours and see how each layout comes together in motion. As you click through, look for open kitchen-to-living flow, wood-style flooring, breakfast-bar seating, tile backsplashes, sliding-glass-door light, and details like modern cabinetry and in-home laundry that are easier to appreciate room by room.</p><p>Use the tours to compare finishes, sightlines, storage, and outdoor connections from wherever you are, then visit <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite spaces in Brandon in person.</p>",
  "property_copyright": "2025 All Rights Reserved. The Griffin",
  "property_seo_title_home": "The Griffin | Apartments in Brandon, FL",
  "property_seo_description_home": "Discover your ideal living space at The Griffin in Brandon, FL! Our stunning apartment community offers thoughtfully designed floor plans, featuring one, two, and three-bedroom options. Enjoy an array of top-notch amenities, including a resort-style pool, fitness center, dog park, and online resident services. With smart locks, walk-in closets, and beautiful views, comfort and convenience are at your fingertips. Explore all we have to offer and find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Brandon, FL",
  "property_seo_description_floorplans": "Discover your ideal living space at The Griffin in Brandon, FL! Explore our diverse floor plans, featuring stylish one, two, and three-bedroom apartments designed for comfort and convenience. Browse our available apartment homes today and find the perfect fit for your lifestyle!",
  "property_seo_title_amenities": "Amenities | Brandon, FL Apartments for Rent",
  "property_seo_description_amenities": "Discover luxury living at The Griffin in Brandon, FL! Choose from spacious one-, two-, and three-bedroom floor plans designed for your comfort. Enjoy top-notch amenities including a resort-style pool, fitness center, dog park, and online resident services. With features like smart locks, walk-in closets, and stylish tile backsplashes, your home will be both functional and beautiful. Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Brandon, FL",
  "property_seo_description_gallery": "Discover your dream home at The Griffin in Brandon, FL! Explore our stunning photo gallery showcasing spacious one, two, and three-bedroom floor plans, complete with luxurious amenities such as a resort-style pool, fitness center, and a dog park. Enjoy modern comforts like smart locks, USB outlets, and in-unit W&D, or relax on the sundeck with picturesque lake and wood views. Picture yourself living here and embrace the perfect blend of style and convenience. View more and take the next step to your new lifestyle today!",
  "property_seo_title_virtualtours": "Virtual Tours | The Griffin Apartments",
  "property_seo_description_virtualtours": "Explore The Griffin in Brandon, FL! Discover our spacious floor plans, featuring one, two, and three-bedroom apartments designed for your lifestyle. Take a virtual tour today and picture yourself in your new home. Don't miss out—view all available options!",
  "property_seo_title_interactivemap": "Interactive Map | The Griffin Apartments",
  "property_seo_description_interactivemap": "Discover your dream apartment at The Griffin in Brandon, FL! Explore our diverse floor plans—one, two, and three-bedroom options—along with exceptional amenities like a resort-style pool, fitness center, dog park, and smart home features. Enjoy modern conveniences including USB outlets, walk-in closets, and a fenced yard. Dive into a vibrant community atmosphere with online resident services, a clubhouse, and a grill area. Use our interactive community map to find available apartments and pricing today—your perfect home awaits at The Griffin!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Brandon, FL",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding The Griffin in Brandon, FL! Explore our one, two, and three-bedroom apartments and uncover local favorites, parks, dining, and entertainment right at your doorstep. See what's around our community and make The Griffin your new home today!",
  "property_seo_title_contact": "Contact Us | The Griffin",
  "property_seo_description_contact": "Discover your ideal home at The Griffin in Brandon, FL! Explore our diverse floor plans featuring one, two, and three-bedroom apartments designed for comfort and style. Have questions? Contact our leasing team today for personalized assistance!",
  "property_seo_title_faqs": "FAQs | Apartments in Brandon, FL",
  "property_seo_description_faqs": "Discover your ideal living space at The Griffin in Brandon, FL! Explore our diverse floor plans, including one, two, and three-bedroom options tailored for your comfort. Enjoy exceptional amenities such as a resort-style pool, fitness center, dog park, and the convenience of online resident services. Have questions? Browse our FAQs page for insights into our community features, like smart locks, walk-in closets, and lake views. Join The Griffin and elevate your lifestyle today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Brandon, FL",
  "property_seo_description_reviews": "Discover the vibrant lifestyle at The Griffin in Brandon, FL! Explore our spacious one, two, and three-bedroom floor plans, each designed for comfort and convenience. Enjoy top-notch amenities including a resort-style pool, fitness center, and dog park, alongside modern comforts like smart locks and USB outlets. Don't just take our word for it—**see what our residents have to say about living at our community!** Experience the perfect blend of luxury and community at The Griffin.",
  "property_seo_title_applynow": "Apply Now | Apartments in Brandon, FL",
  "property_seo_description_applynow": "Discover your perfect home at The Griffin in Brandon, FL! With spacious one, two, and three-bedroom floor plans, our community offers top-tier amenities including a resort-style pool, fitness center, and dog park. Enjoy modern comforts like smart locks, walk-in closets, and included appliances, all while taking advantage of our online resident services and valet trash. Embrace a lifestyle of convenience and luxury—apply now and lease your new apartment online today!",
  "property_seo_title_residentaccess": "Resident Access | The Griffin",
  "property_seo_description_residentaccess": "\"Welcome to The Griffin in Brandon, FL! Access your resident portal for convenient online rent payments, hassle-free maintenance scheduling, and essential community updates. Log in now to enhance your living experience!\"",
  "property_seo_title_referafriend": "Refer A Friend | The Griffin",
  "property_seo_description_referafriend": "\"Refer a friend to The Griffin in Brandon, FL, where great friends make great neighbors! Enjoy a vibrant community, top-notch amenities, and the comfort of home. Help your loved ones discover their new haven today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | The Griffin",
  "property_seo_description_scheduletour": "\"Experience luxury living at The Griffin in Brandon, FL! Schedule a tour of our stunning apartment community today and discover your new home with top amenities, beautiful surroundings, and a welcoming atmosphere. Don't miss out—explore our vibrant community today!\"",
  "property_seo_title_privacy": "Privacy Policy | The Griffin",
  "property_seo_description_privacy": "\"Discover The Griffin in Brandon, FL, where your privacy matters! Our comprehensive privacy policy outlines how we protect your personal information. Trust us to keep your data secure. View our privacy policy today!\"",
  "property_seo_title_accessibility": "Website Accessibility | The Griffin",
  "property_seo_description_accessibility": "\"Discover The Griffin in Brandon, FL—where accessibility meets comfort. Our commitment to digital inclusion ensures everyone can navigate our community with ease. Explore our Accessibility Statement to learn more about our efforts to create an inclusive living experience. Join us in making a difference today!\"",
  "property_seo_title_sitemap": "Sitemap | The Griffin",
  "property_seo_description_sitemap": "Discover the layout of The Griffin in Brandon, FL! Explore our sitemap to easily navigate our apartment community's offerings, amenities, and services. Join us to find your perfect home today—view our website sitemap now!",
  "property_seo_title_thankyou": "Thank You | The Griffin",
  "property_seo_description_thankyou": "Thank you for your interest in The Griffin in Brandon, FL! Your information has been received, and a team member will reach out shortly to assist you in finding your perfect apartment home. Stay tuned for more about our vibrant community and exceptional living experience!",
  "property_seo_title_pets": "Pet Policy | Apartments in Buford, GA\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234321231",
  "amenities": [
    {
      "id": "custom_3abb1dc3-1cd5-4612-9cd6-12d9303384d6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Sleek Quartz or Granite Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_05d011d8-36fe-49d4-9afe-42d33e310b56",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Wood Style Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_168ea155-641c-445c-a5ed-463262a2cc82",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Premium Black or Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_36b29a63-84e6-4479-b816-a9cb3af14b66",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryers",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7d3278e2-e412-4b1d-afd7-a60f45b9c19f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "external_id": "P000000632",
      "title": "Fenced Yard",
      "amount": "0.0000",
      "description": "Screened In Private Patios & Balconies",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8de7e784-071e-4ed4-b07c-7d2a55d51665",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Decorative Tile Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_91a3847d-fe19-4d5c-9fd6-2251d99f0503",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "external_id": "P000000698",
      "title": "USB Outlet",
      "amount": "0.0000",
      "description": "Wall Outlets with USB Ports",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_02131fc1-7c0b-4514-81ba-74aa6ca1d0ef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Generous Closets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_acd3fc66-bc6b-4f0e-9109-487b39a680e8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "external_id": "P000000687",
      "title": "Storage Spaces",
      "amount": "0.0000",
      "description": "Storage*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_add717fd-b853-471a-aa76-7ff681fad391",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "external_id": "P000002405",
      "title": "Resort Style Pool",
      "amount": "0.0000",
      "description": "Two Resort Style Pools",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b4211e03-3d22-4575-9743-1357ac010d93",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "external_id": "P000000688",
      "title": "Sundeck",
      "amount": "0.0000",
      "description": "Relaxing Poolside Sundeck",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1992fbb1-4cd5-426e-84fe-520e07eb62fb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Two Fitness Centers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_28011ead-c7ff-4e33-b619-5854138ca016",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Leash-Free Bark Park",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5b45948b-1ed2-4080-b6b8-8be85d09a38c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "external_id": "P000002365",
      "title": "Conference Room",
      "amount": "0.0000",
      "description": "Community Conference Rooms",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a2f90f13-58bb-48c1-8546-a9d8b8fed5fa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "external_id": "P000000644",
      "title": "Grill Area",
      "amount": "0.0000",
      "description": "Community Grilling Areas",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b21265ad-fccd-4e46-be19-9e1c4e6449ae",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "external_id": "P000000640",
      "title": "Garages",
      "amount": "0.0000",
      "description": "Garages Available",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6228b438-a37d-489b-8ed4-ae99630241bb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "external_id": "P000000665",
      "title": "Package System",
      "amount": "0.0000",
      "description": "24-Hour Resident Package System**",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_35e8bf70-3ee1-41ab-8556-d34ae498916b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "external_id": "P000002458",
      "title": "Valet Trash Service",
      "amount": "0.0000",
      "description": "Valet Trash Service",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5ee47c3d-3962-44b6-ac23-9f8b334e8893",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "external_id": "P000002520",
      "title": "Resident Clubhouse",
      "amount": "0.0000",
      "description": "Resident Clubhouse",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_17ee789f-b5b2-40d8-9e4b-cd9db3b98368",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_af7e2c43-e787-4f4c-84ce-37cd0a8f2231",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "external_id": "P000002561",
      "title": "RentPlus",
      "amount": "0.0000",
      "description": "Credit Building powered by RentPlus",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_76d018c8-b420-48e8-a782-b39b2190ec28",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "external_id": "P000002563",
      "title": "Spruce",
      "amount": "0.0000",
      "description": "Spruce",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6481af16-7342-4ecc-93e5-d4de1e49e64a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_14bd5793-be21-43c2-a12d-9f428b88d877",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89fa-68d1-76be-8ddc-f5945a267cbe.webp",
      "image_media": {
        "alt_text": "Apartment community grounds with picnic tables and cornhole game.",
        "public_id": "019e89fa-68d1-76be-8ddc-f5945a267cbe",
        "storage_key": "property/6767906449163357/019e89fa-68d1-76be-8ddc-f5945a267cbe.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation and relaxation on the grounds of the apartment community, featuring picnic areas and a cornhole game court.",
      "link": "",
      "alt_text": "Apartment community grounds with picnic tables and cornhole game.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c7de5a7b-4d52-4537-8674-3624ca4b57f8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89fa-650c-762c-b61d-e24104718541.webp",
      "image_media": {
        "alt_text": "Modern conference room with a large dark table, white chairs, abstract art, and a TV.",
        "public_id": "019e89fa-650c-762c-b61d-e24104718541",
        "storage_key": "property/6767906449163357/019e89fa-650c-762c-b61d-e24104718541.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Host your next meeting in our stylish conference room, equipped with a large table, comfortable seating, and A/V equipment for presentations.",
      "link": "",
      "alt_text": "Modern conference room with a large dark table, white chairs, abstract art, and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_22bc18eb-4c47-4fe2-b429-fe37a8198af5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89fa-640a-722c-8a88-cb788b1e468f.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with dual sinks, large mirror, and gray cabinets.",
        "public_id": "019e89fa-640a-722c-8a88-cb788b1e468f",
        "storage_key": "property/6767906449163357/019e89fa-640a-722c-8a88-cb788b1e468f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Elegant bathroom featuring a spacious vanity with ample counter space, a large mirror, and modern gray cabinetry. The bathtub with a white shower curtain adds a touch of sophistication.",
      "link": "",
      "alt_text": "Modern bathroom vanity with dual sinks, large mirror, and gray cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_557abb6e-a6b7-453a-be4b-17dadc3eeda5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89fa-4aa2-74e8-bd07-ee2e1a30064d.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019e89fa-4aa2-74e8-bd07-ee2e1a30064d",
        "storage_key": "property/6767906449163357/019e89fa-4aa2-74e8-bd07-ee2e1a30064d.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning swimming pool, surrounded by lush landscaping and comfortable lounge seating.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1222e6be-95fc-4d0f-af4e-51ce9af6920e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89fa-4bcb-77a3-9b1f-ac0fb6d303f0.webp",
      "image_media": {
        "alt_text": "Fully equipped gym with cardio machines, weightlifting equipment, and free weights.",
        "public_id": "019e89fa-4bcb-77a3-9b1f-ac0fb6d303f0",
        "storage_key": "property/6767906449163357/019e89fa-4bcb-77a3-9b1f-ac0fb6d303f0.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring a comprehensive range of cardio and strength training equipment.",
      "link": "",
      "alt_text": "Fully equipped gym with cardio machines, weightlifting equipment, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_256da63a-ace5-461b-a6ae-3078f9db23c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89fa-47af-767d-8ecd-52f0b536b20f.webp",
      "image_media": {
        "alt_text": "Outdoor grassy area with a red bench in the foreground and apartment buildings in the background.",
        "public_id": "019e89fa-47af-767d-8ecd-52f0b536b20f",
        "storage_key": "property/6767906449163357/019e89fa-47af-767d-8ecd-52f0b536b20f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy the spacious outdoor common areas and pet-friendly amenities at our community. Perfect for relaxing or letting your furry friends play.",
      "link": "",
      "alt_text": "Outdoor grassy area with a red bench in the foreground and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ea5064a3-d43c-407f-bb87-c840e7f2ed58",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89fa-4815-7373-a4ce-df73e817870f.webp",
      "image_media": {
        "alt_text": "Luxurious bedroom with a king-size bed, warm accent wall, and large window.",
        "public_id": "019e89fa-4815-7373-a4ce-df73e817870f",
        "storage_key": "property/6767906449163357/019e89fa-4815-7373-a4ce-df73e817870f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed bedroom. Featuring a plush king-size bed, stylish decor, and ample natural light, it's the perfect retreat.",
      "link": "",
      "alt_text": "Luxurious bedroom with a king-size bed, warm accent wall, and large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_64ab252a-fe26-40d4-a463-badebe3f077a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89fa-40c2-72cf-81b9-d31d53e04a6a.webp",
      "image_media": {
        "alt_text": "A well-equipped gym with weights, machines, and a colorful mural.",
        "public_id": "019e89fa-40c2-72cf-81b9-d31d53e04a6a",
        "storage_key": "property/6767906449163357/019e89fa-40c2-72cf-81b9-d31d53e04a6a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide array of free weights, cardio machines, and strength training equipment. Enjoy a vibrant atmosphere with a unique, colorful mural as your backdrop.",
      "link": "",
      "alt_text": "A well-equipped gym with weights, machines, and a colorful mural.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e89837e9-f14a-44ec-b4bf-07e04ae27bc6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89fa-4160-71fc-88b1-5f5c63cc80ed.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019e89fa-4160-71fc-88b1-5f5c63cc80ed",
        "storage_key": "property/6767906449163357/019e89fa-4160-71fc-88b1-5f5c63cc80ed.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind by our beautiful resort-style swimming pool, surrounded by lush palm trees and comfortable lounge chairs. Perfect for soaking up the sun or enjoying a refreshing dip.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d6a5fbb9-1084-4be4-a77d-f8e470657045",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89fa-4188-7428-8005-8c8100016f8a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with breakfast bar, black appliances, and gray cabinets.",
        "public_id": "019e89fa-4188-7428-8005-8c8100016f8a",
        "storage_key": "property/6767906449163357/019e89fa-4188-7428-8005-8c8100016f8a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring a quartz breakfast bar, sleek gray cabinetry, and modern black appliances, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with breakfast bar, black appliances, and gray cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_549ddea5-f3fc-4cc9-84e0-80a0d2f18727",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89fa-4298-7409-a1f4-e0ecf9aedb3d.webp",
      "image_media": {
        "alt_text": "Modern lobby with a curved gray sofa, coffee table, and decorative art.",
        "public_id": "019e89fa-4298-7409-a1f4-e0ecf9aedb3d",
        "storage_key": "property/6767906449163357/019e89fa-4298-7409-a1f4-e0ecf9aedb3d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax in our stylish and modern lobby, featuring comfortable seating and elegant decor. A perfect space to unwind or greet guests.",
      "link": "",
      "alt_text": "Modern lobby with a curved gray sofa, coffee table, and decorative art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9b98dad6-ee66-4e38-b89d-35d838a19575",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89fa-436a-762f-b078-c6e377392b1a.webp",
      "image_media": {
        "alt_text": "Living room with a brown sofa, armchair, coffee table, and accent wall.",
        "public_id": "019e89fa-436a-762f-b078-c6e377392b1a",
        "storage_key": "property/6767906449163357/019e89fa-436a-762f-b078-c6e377392b1a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a plush brown sofa, a modern armchair, a chic coffee table, and a unique accent wall. Access to a patio or balcony is visible through sliding glass doors.",
      "link": "",
      "alt_text": "Living room with a brown sofa, armchair, coffee table, and accent wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cd0beb51-7571-4674-89be-3c3c72fa1e11",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89fa-3e33-70f8-9819-65e6395dd39b.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with manicured lawns and pathways.",
        "public_id": "019e89fa-3e33-70f8-9819-65e6395dd39b",
        "storage_key": "property/6767906449163357/019e89fa-3e33-70f8-9819-65e6395dd39b.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Beautifully maintained apartment buildings featuring lush green lawns and winding walkways, creating an inviting community atmosphere.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with manicured lawns and pathways.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_17feecfd-12fc-459a-b843-6075583bdbd1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89fa-2e4c-769c-beb7-070e2a25169a.webp",
      "image_media": {
        "alt_text": "Modern open-concept living area with a sleek kitchen, dining table, and living room furniture.",
        "public_id": "019e89fa-2e4c-769c-beb7-070e2a25169a",
        "storage_key": "property/6767906449163357/019e89fa-2e4c-769c-beb7-070e2a25169a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this stylish open-concept apartment, featuring a modern kitchen, elegant dining area, and a spacious living room perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Modern open-concept living area with a sleek kitchen, dining table, and living room furniture.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ec4b4d89-2156-4bb3-9faf-9ad087791a2e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89fa-2cfd-759f-9fda-faeed1d85491.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and palm trees.",
        "public_id": "019e89fa-2cfd-759f-9fda-faeed1d85491",
        "storage_key": "property/6767906449163357/019e89fa-2cfd-759f-9fda-faeed1d85491.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, complete with comfortable lounge chairs and lush landscaping. Perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_64d7732f-f3a4-4045-8dec-9dd5d3ba4886",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89fa-22de-758b-bf03-ea0092f4c5c6.webp",
      "image_media": {
        "alt_text": "Modern relaxation nook with artificial turf, indoor plants, a massage gun, and a comfortable chair.",
        "public_id": "019e89fa-22de-758b-bf03-ea0092f4c5c6",
        "storage_key": "property/6767906449163357/019e89fa-22de-758b-bf03-ea0092f4c5c6.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Unwind in our serene relaxation space, featuring lush greenery, artificial turf, and a massage gun for ultimate rejuvenation. Perfect for destressing after a long day.",
      "link": "",
      "alt_text": "Modern relaxation nook with artificial turf, indoor plants, a massage gun, and a comfortable chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_82a54628-bd76-4369-82d2-b18c5714d8d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89fa-2a92-74b0-b0db-e81d00445bb5.webp",
      "image_media": {
        "alt_text": "Modern dining booths with contemporary lighting and abstract wall art.",
        "public_id": "019e89fa-2a92-74b0-b0db-e81d00445bb5",
        "storage_key": "property/6767906449163357/019e89fa-2a92-74b0-b0db-e81d00445bb5.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a chic and comfortable dining experience in our community's stylish booths, perfect for casual meals or social gatherings.",
      "link": "",
      "alt_text": "Modern dining booths with contemporary lighting and abstract wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_eee4a6c4-40e0-4ed6-8664-582a14180a40",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89fa-29e5-73af-a2fe-46f84dce04e4.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer in a closet next to a dining area.",
        "public_id": "019e89fa-29e5-73af-a2fe-46f84dce04e4",
        "storage_key": "property/6767906449163357/019e89fa-29e5-73af-a2fe-46f84dce04e4.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of an in-unit washer and dryer, perfectly situated next to your dining space for ultimate ease.",
      "link": "",
      "alt_text": "In-unit washer and dryer in a closet next to a dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1b1abe1e-30ca-4a3c-be74-d56f8e9c2159",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89fa-277b-77f1-8269-12baf987bfcc.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a circular green couch and a fire pit in the center.",
        "public_id": "019e89fa-277b-77f1-8269-12baf987bfcc",
        "storage_key": "property/6767906449163357/019e89fa-277b-77f1-8269-12baf987bfcc.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy the outdoors with comfortable seating around a fire pit, perfect for gathering with friends and neighbors.",
      "link": "",
      "alt_text": "Outdoor seating area with a circular green couch and a fire pit in the center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_674f5ccc-fece-45c3-a916-eda3104aefe7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89fa-229a-7613-830d-97a24b4963a8.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a bathtub, sink, and closet.",
        "public_id": "019e89fa-229a-7613-830d-97a24b4963a8",
        "storage_key": "property/6767906449163357/019e89fa-229a-7613-830d-97a24b4963a8.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish bathroom featuring a deep soaking tub with a bamboo caddy, a sleek vanity with a modern faucet, and a spacious walk-in closet.",
      "link": "",
      "alt_text": "Modern bathroom with a bathtub, sink, and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2e336706-113f-454e-94ff-ef5bf80a2f93",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89fa-1ec4-70da-a529-f255d92e9e60.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a large bed, accent chairs, and a window with blinds.",
        "public_id": "019e89fa-1ec4-70da-a529-f255d92e9e60",
        "storage_key": "property/6767906449163357/019e89fa-1ec4-70da-a529-f255d92e9e60.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Experience ultimate comfort in this beautifully designed bedroom, featuring a king-size bed, plush seating, and abundant natural light.",
      "link": "",
      "alt_text": "Stylish bedroom with a large bed, accent chairs, and a window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f5ad73d8-29fd-4f6a-9285-d42106b5eaff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89fa-1c82-76ce-9d67-c910d527e2fb.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with two stainless steel grills and a picnic table under a white umbrella.",
        "public_id": "019e89fa-1c82-76ce-9d67-c910d527e2fb",
        "storage_key": "property/6767906449163357/019e89fa-1c82-76ce-9d67-c910d527e2fb.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy al fresco dining with our community's outdoor grilling stations, perfect for BBQs with friends and family.",
      "link": "",
      "alt_text": "Outdoor grilling area with two stainless steel grills and a picnic table under a white umbrella.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b31f98b1-f1dd-464f-a91e-06b1c7268462",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89fa-2163-748f-a9d5-7d925c097a9c.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019e89fa-2163-748f-a9d5-7d925c097a9c",
        "storage_key": "property/6767906449163357/019e89fa-2163-748f-a9d5-7d925c097a9c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ce2ba478-f68f-4acb-9a20-8e400e4dd5ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89fa-0e0d-71cc-9abc-e68635f2f89a.webp",
      "image_media": {
        "alt_text": "Round dining table with four chairs and kitchen counter with bar stools in apartment.",
        "public_id": "019e89fa-0e0d-71cc-9abc-e68635f2f89a",
        "storage_key": "property/6767906449163357/019e89fa-0e0d-71cc-9abc-e68635f2f89a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A modern dining area with a round table, upholstered chairs, and a breakfast bar with stools, adjacent to a fully equipped kitchen.",
      "link": "",
      "alt_text": "Round dining table with four chairs and kitchen counter with bar stools in apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b3f40153-e860-40f4-be45-e6c72c89b82b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89f9-feec-73b8-9e57-7e80fb435aea.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with garages and palm trees.",
        "public_id": "019e89f9-feec-73b8-9e57-7e80fb435aea",
        "storage_key": "property/6767906449163357/019e89f9-feec-73b8-9e57-7e80fb435aea.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Modern apartment building exterior featuring attached garages and lush palm trees, creating a welcoming community atmosphere.",
      "link": "",
      "alt_text": "Exterior view of apartment building with garages and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dbc87fea-2ac5-441e-a3ba-896ca07a8284",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89fa-006f-73fa-b53c-897925da3798.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with wire shelving and wood flooring",
        "public_id": "019e89fa-006f-73fa-b53c-897925da3798",
        "storage_key": "property/6767906449163357/019e89fa-006f-73fa-b53c-897925da3798.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving and natural light, perfect for organizing your wardrobe.",
      "link": "",
      "alt_text": "Empty walk-in closet with wire shelving and wood flooring",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3ed65079-ac9f-494c-892f-59a3c5609ae8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89f9-fcd3-7268-8fc6-6488e307e698.webp",
      "image_media": {
        "alt_text": "The Griffin apartment building lobby with a green sofa, marble coffee table, and reception desk.",
        "public_id": "019e89f9-fcd3-7268-8fc6-6488e307e698",
        "storage_key": "property/6767906449163357/019e89f9-fcd3-7268-8fc6-6488e307e698.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Welcome to The Griffin's stylish lobby, featuring comfortable seating and a modern reception area. Experience luxury living in our beautiful community.",
      "link": "",
      "alt_text": "The Griffin apartment building lobby with a green sofa, marble coffee table, and reception desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9cdeee86-995f-4e38-8b9e-fd20aecb6fc8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89f9-ff33-702d-8f51-42eecb58d659.webp",
      "image_media": {
        "alt_text": "Living room with dining area and open kitchen in a modern apartment.",
        "public_id": "019e89f9-ff33-702d-8f51-42eecb58d659",
        "storage_key": "property/6767906449163357/019e89f9-ff33-702d-8f51-42eecb58d659.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish living and dining area with an open-concept kitchen. Perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Living room with dining area and open kitchen in a modern apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_038054d3-4cd8-4f3d-92f8-c96ec75686bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89f9-fefc-76bb-8c81-189a5f3f61cf.webp",
      "image_media": {
        "alt_text": "Community lounge with a coffee bar and seating area.",
        "public_id": "019e89f9-fefc-76bb-8c81-189a5f3f61cf",
        "storage_key": "property/6767906449163357/019e89f9-fefc-76bb-8c81-189a5f3f61cf.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and socialize in the community lounge, featuring a coffee bar and comfortable seating.",
      "link": "",
      "alt_text": "Community lounge with a coffee bar and seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d37490cf-4ff9-41cf-aade-aa4278aff7e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89f9-ff05-73a5-8a43-f253dbf593be.webp",
      "image_media": {
        "alt_text": "The Griffin apartment complex monument sign with landscaping.",
        "public_id": "019e89f9-ff05-73a5-8a43-f253dbf593be",
        "storage_key": "property/6767906449163357/019e89f9-ff05-73a5-8a43-f253dbf593be.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Welcome to The Griffin, a premier apartment community. This image shows the property's elegant monument sign surrounded by lush landscaping and mature trees.",
      "link": "",
      "alt_text": "The Griffin apartment complex monument sign with landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_59457173-4c59-4bd4-acfa-60c2b64c3b7b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89f9-fed2-74c0-b6b6-6bfecc983dc6.webp",
      "image_media": {
        "alt_text": "Fully equipped gym with cardio machines, weight machines, and free weights.",
        "public_id": "019e89f9-fed2-74c0-b6b6-6bfecc983dc6",
        "storage_key": "property/6767906449163357/019e89f9-fed2-74c0-b6b6-6bfecc983dc6.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide range of cardio and strength training equipment.",
      "link": "",
      "alt_text": "Fully equipped gym with cardio machines, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e8df19ee-6783-42b0-b05f-20c639e4be80",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89f9-ffb5-764d-80b6-54156c599d02.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas in front of an apartment building.",
        "public_id": "019e89f9-ffb5-764d-80b6-54156c599d02",
        "storage_key": "property/6767906449163357/019e89f9-ffb5-764d-80b6-54156c599d02.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded umbrellas. Enjoy the resort-style amenities at our community.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas in front of an apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8ccaf925-e10e-4f5c-a6bd-fe2e914918c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89f9-fe53-74f8-ab82-a9fa6d1504a7.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and seating areas, adjacent to apartment buildings.",
        "public_id": "019e89f9-fe53-74f8-ab82-a9fa6d1504a7",
        "storage_key": "property/6767906449163357/019e89f9-fe53-74f8-ab82-a9fa6d1504a7.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our resort-style pool, surrounded by lush landscaping and comfortable seating. Perfect for relaxing or socializing.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and seating areas, adjacent to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8a688383-a61b-4ca4-94a6-25286fc33017",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89f9-e83c-7573-9bc8-16cf05baa3e5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and subway tile backsplash.",
        "public_id": "019e89f9-e83c-7573-9bc8-16cf05baa3e5",
        "storage_key": "property/6767906449163357/019e89f9-e83c-7573-9bc8-16cf05baa3e5.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed kitchen, featuring sleek white cabinetry, modern stainless steel appliances, and a classic subway tile backsplash. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_6779a88565c9f2fff1e1559e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Just Love Coffee Cafe - Brandon, FL",
      "poi_type": "Restaurants",
      "poi_address": "2020 W Brandon Blvd Ste 105, Brandon, FL 33511, USA",
      "poi_short_description": "Casual, contemporary coffeehouse and cafe that serves breakfast and lunch fare along with hand-brewed coffee.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-50f0-7329-9469-3e4dfa0ea3f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-50f0-7329-9469-3e4dfa0ea3f9",
        "storage_key": "property/6767906449163357/019f14e4-50f0-7329-9469-3e4dfa0ea3f9.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://justlovecoffeecafe.com/fl-brandon/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2621306520985911778&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "just-love-coffee-cafe---brandon-fl",
      "poi_latitude": "27.9382353",
      "poi_longitude": "-82.3171784",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 813-381-4395",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e5-2640-746e-9f21-6587dbb20d8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-2640-746e-9f21-6587dbb20d8c",
        "storage_key": "property/6767906449163357/019f14e5-2640-746e-9f21-6587dbb20d8c.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJjZrtFU_PwogR4sHHfmTAYCQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_77f29c40b22f1ecad17a8331",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Raining Berries - Brandon",
      "poi_type": "Restaurants",
      "poi_address": "1560 W Brandon Blvd, Brandon, FL 33511, USA",
      "poi_short_description": "A selection of coffee beverages from cold brew to pumpkin spice lattes, as well as açaí bowls and smoothies.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-62f6-7760-9361-0758fd4ae123.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-62f6-7760-9361-0758fd4ae123",
        "storage_key": "property/6767906449163357/019f14e4-62f6-7760-9361-0758fd4ae123.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.rainingberries.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17570075632366503228&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "raining-berries---brandon",
      "poi_latitude": "27.9388393",
      "poi_longitude": "-82.3087853",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 813-324-8924",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fb0-7399-a89d-41bd9494868e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fb0-7399-a89d-41bd9494868e",
        "storage_key": "property/6767906449163357/019f14e2-7fb0-7399-a89d-41bd9494868e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFWK8YNvPwogRPMXzh7Jy1fM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "acai_shop"
    },
    {
      "id": "ec_f829edaed8f707e878de484f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Keke's Breakfast Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1590 W Brandon Blvd, Brandon, FL 33511, USA",
      "poi_short_description": "Local chain serving American breakfasts & comfort-food lunches in a modern diner with booth seating.",
      "poi_long_description": "Local chain serving American breakfasts & comfort-food lunches in a modern diner with booth seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-699e-71f5-a910-911918d907c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-699e-71f5-a910-911918d907c8",
        "storage_key": "property/6767906449163357/019f14e4-699e-71f5-a910-911918d907c8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kekes.com/locations/kekes-brandon?utm_source=gbp&utm_medium=organic&utm_campaign=KKB_Brandon_gbp_organic_evergreen",
      "poi_directions_map_url": "https://maps.google.com/?cid=12021349916895324894&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kekes-breakfast-cafe",
      "poi_latitude": "27.9389492",
      "poi_longitude": "-82.30990419999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 813-655-0565",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fb0-7399-a89d-41bd9494868e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fb0-7399-a89d-41bd9494868e",
        "storage_key": "property/6767906449163357/019f14e2-7fb0-7399-a89d-41bd9494868e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD0p91TvPwogR3qo3vQ5q1KY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "ec_cec5a539f2a64abf9c285a4e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Bolay Fresh Bold Kitchen - Brandon",
      "poi_type": "Restaurants",
      "poi_address": "1544 W Brandon Blvd Unit 102, Brandon, FL 33510, USA",
      "poi_short_description": "Healthy eatery offering gluten-free, rice, noodle or salad bowls with your choice of proteins and vegetables.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-5614-76e8-b004-54b2fcee5777.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-5614-76e8-b004-54b2fcee5777",
        "storage_key": "property/6767906449163357/019f14e4-5614-76e8-b004-54b2fcee5777.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.bolay.com/?utm_source=gmb&utm_medium=cta&utm_campaign=218",
      "poi_directions_map_url": "https://maps.google.com/?cid=118326161024169411&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bolay-fresh-bold-kitchen---brandon",
      "poi_latitude": "27.9380649",
      "poi_longitude": "-82.3079776",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 813-412-5085",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fb0-7399-a89d-41bd9494868e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fb0-7399-a89d-41bd9494868e",
        "storage_key": "property/6767906449163357/019f14e2-7fb0-7399-a89d-41bd9494868e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ45xJiF3PwogRwzV7OwRhpAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_dc915dc3bdb442ef752ebeeb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Tibby's New Orleans Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "1721 W Brandon Blvd, Brandon, FL 33511, USA",
      "poi_short_description": "Colorful eatery offering gumbo, fried crawfish & other classic Cajun-Creole dishes, plus cocktails.",
      "poi_long_description": "Colorful eatery offering gumbo, fried crawfish & other classic Cajun-Creole dishes, plus cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-9d86-749f-bdf0-e7a104eb10f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-9d86-749f-bdf0-e7a104eb10f8",
        "storage_key": "property/6767906449163357/019f14e4-9d86-749f-bdf0-e7a104eb10f8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://tibbys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13580928016225856044&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tibbys-new-orleans-kitchen",
      "poi_latitude": "27.9370813",
      "poi_longitude": "-82.3113463",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 813-315-8443",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fb0-7399-a89d-41bd9494868e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fb0-7399-a89d-41bd9494868e",
        "storage_key": "property/6767906449163357/019f14e2-7fb0-7399-a89d-41bd9494868e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJr-QLQHvOwogRLOpKbxMmebw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cajun_restaurant"
    },
    {
      "id": "ec_a13a5408563e05010a6c7c97",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Portillo's Brandon",
      "poi_type": "Restaurants",
      "poi_address": "1748 W Brandon Blvd, Brandon, FL 33511, USA",
      "poi_short_description": "Chicago-born chain for hot dogs, Italian beef sandwiches & more, plus beer & wine, in retro digs.",
      "poi_long_description": "Chicago-born chain for hot dogs, Italian beef sandwiches & more, plus beer & wine, in retro digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-55fd-75d1-939a-2a2441f8b506.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-55fd-75d1-939a-2a2441f8b506",
        "storage_key": "property/6767906449163357/019f14e4-55fd-75d1-939a-2a2441f8b506.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.portillos.com/locations/brandon/?utm_source=google&utm_medium=yext&utm_campaign=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=120965208236634062&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "portillos-brandon",
      "poi_latitude": "27.9381924",
      "poi_longitude": "-82.3118341",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 813-210-8190",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fb0-7399-a89d-41bd9494868e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fb0-7399-a89d-41bd9494868e",
        "storage_key": "property/6767906449163357/019f14e2-7fb0-7399-a89d-41bd9494868e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ18BcqzNwogRzi8gSzfBrQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_9515877e630fd8e853985d78",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Bonefish Grill",
      "poi_type": "Restaurants",
      "poi_address": "1015 Providence Rd, Brandon, FL 33511, USA",
      "poi_short_description": "Contemporary grill chain offering a seafood-centric menu, plus steaks & cocktails.",
      "poi_long_description": "Contemporary grill chain offering a seafood-centric menu, plus steaks & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-622a-7287-acf3-7141a2347743.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-622a-7287-acf3-7141a2347743",
        "storage_key": "property/6767906449163357/019f14e4-622a-7287-acf3-7141a2347743.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.bonefishgrill.com/florida/brandon/1015-providence-road?y_source=1_MTU1MDI2NzUtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12738209197423221582&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bonefish-grill",
      "poi_latitude": "27.9220038",
      "poi_longitude": "-82.31794049999999",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 813-571-5553",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fb0-7399-a89d-41bd9494868e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fb0-7399-a89d-41bd9494868e",
        "storage_key": "property/6767906449163357/019f14e2-7fb0-7399-a89d-41bd9494868e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyd6qV2vOwogRTlsGb8Y1x7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_a24a0e3927cb99e9a1d4b82f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Stonewood Grill & Tavern",
      "poi_type": "Restaurants",
      "poi_address": "612 E Bloomingdale Ave, Brandon, FL 33511, USA",
      "poi_short_description": "Chophouse chain serving surf 'n' turf, wine & cocktails in a stylish dining room & bar.",
      "poi_long_description": "Chophouse chain serving surf 'n' turf, wine & cocktails in a stylish dining room & bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-6ea7-7528-a925-557f2b5f9a6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-6ea7-7528-a925-557f2b5f9a6d",
        "storage_key": "property/6767906449163357/019f14e4-6ea7-7528-a925-557f2b5f9a6d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://stonewoodgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4318687320823556001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stonewood-grill--tavern",
      "poi_latitude": "27.8939306",
      "poi_longitude": "-82.2736472",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 813-655-9561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fb0-7399-a89d-41bd9494868e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fb0-7399-a89d-41bd9494868e",
        "storage_key": "property/6767906449163357/019f14e2-7fb0-7399-a89d-41bd9494868e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtUc0bHbSwogRoeerpTwP7zs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_440af726fa9c987718864605",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "The Stein & Vine",
      "poi_type": "Restaurants",
      "poi_address": "827 W Bloomingdale Ave, Brandon, FL 33511, USA",
      "poi_short_description": "Chill, woodsy bar offering craft beer & wine to go with American, Southern & creative global fare.",
      "poi_long_description": "Chill, woodsy bar offering craft beer & wine to go with American, Southern & creative global fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-6e93-7459-b24f-c2329d19b78a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-6e93-7459-b24f-c2329d19b78a",
        "storage_key": "property/6767906449163357/019f14e4-6e93-7459-b24f-c2329d19b78a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thesteinandvine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17838859969011868554&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-stein--vine",
      "poi_latitude": "27.8928517",
      "poi_longitude": "-82.2952171",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 813-655-4786",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e5-2698-71b9-b4f9-63e43fe28d71.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-2698-71b9-b4f9-63e43fe28d71",
        "storage_key": "property/6767906449163357/019f14e5-2698-71b9-b4f9-63e43fe28d71.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYShqxAbSwogRimPjoqBckPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pub"
    },
    {
      "id": "ec_a76bb6865082df3c7e04700e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Allegria Italiana",
      "poi_type": "Restaurants",
      "poi_address": "518 Oakfield Dr, Brandon, FL 33511, USA",
      "poi_short_description": "Warmly decorated eatery for hearty Italian fare, including panini, seafood, veal & flatbread pizza.",
      "poi_long_description": "Warmly decorated eatery for hearty Italian fare, including panini, seafood, veal & flatbread pizza.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-5934-7345-a10e-eccf94ae32f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-5934-7345-a10e-eccf94ae32f1",
        "storage_key": "property/6767906449163357/019f14e4-5934-7345-a10e-eccf94ae32f1.webp",
        "width": 1280,
        "height": 205
      },
      "poi_business_url": "https://allegriaitaliana.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=14454568136813638689&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "allegria-italiana",
      "poi_latitude": "27.933942",
      "poi_longitude": "-82.29160399999999",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 813-651-1166",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fb0-7399-a89d-41bd9494868e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fb0-7399-a89d-41bd9494868e",
        "storage_key": "property/6767906449163357/019f14e2-7fb0-7399-a89d-41bd9494868e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG9HfMdDNwogRIfR0CCPxmMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_a3a7033a5e8e4596ac4af412",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Route 60 Grill",
      "poi_type": "Restaurants",
      "poi_address": "2490 W Brandon Blvd, Brandon, FL 33511, USA",
      "poi_short_description": "Counter-serve restaurant specializing in burgers, chicken wings, gyros, and fries.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-6b25-7296-835c-c8d6c64cc3b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-6b25-7296-835c-c8d6c64cc3b1",
        "storage_key": "property/6767906449163357/019f14e4-6b25-7296-835c-c8d6c64cc3b1.webp",
        "width": 1280,
        "height": 955
      },
      "poi_business_url": "http://www.route60grill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17944923917238964250&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "route-60-grill",
      "poi_latitude": "27.9427193",
      "poi_longitude": "-82.3237089",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 813-315-9655",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fb0-7399-a89d-41bd9494868e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fb0-7399-a89d-41bd9494868e",
        "storage_key": "property/6767906449163357/019f14e2-7fb0-7399-a89d-41bd9494868e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkeeAeQvPwogRGpBw-DktCfk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_630b0e97dcd8958ef131155b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Fountain Plus Endless Hibachi and Sushi Eatery",
      "poi_type": "Restaurants",
      "poi_address": "11245 Causeway Blvd, Brandon, FL 33511, USA",
      "poi_short_description": "Relaxed, family-friendly locale offering all-you-can-eat sushi, hibachi & other Japanese fare.",
      "poi_long_description": "Relaxed, family-friendly locale offering all-you-can-eat sushi, hibachi & other Japanese fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-7a66-71cb-abce-7e80d4c14f95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-7a66-71cb-abce-7e80d4c14f95",
        "storage_key": "property/6767906449163357/019f14e4-7a66-71cb-abce-7e80d4c14f95.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://fountainplussushi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7803026258474889634&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fountain-plus-endless-hibachi-and-sushi-eatery",
      "poi_latitude": "27.9215541",
      "poi_longitude": "-82.32421579999999",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 813-653-2999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fb0-7399-a89d-41bd9494868e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fb0-7399-a89d-41bd9494868e",
        "storage_key": "property/6767906449163357/019f14e2-7fb0-7399-a89d-41bd9494868e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgwoB-j_OwogRovFwNQrrSWw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "ec_c15ea7354e357b5fe6a54a29",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Sake House",
      "poi_type": "Restaurants",
      "poi_address": "760 W Lumsden Rd Unit A, Brandon, FL 33511, USA",
      "poi_short_description": "Japanese spot dishing up sushi, ramen, and other classics, plus beer, sake, and wine.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-7b94-725b-b210-4f278388ace9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-7b94-725b-b210-4f278388ace9",
        "storage_key": "property/6767906449163357/019f14e4-7b94-725b-b210-4f278388ace9.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "https://www.sakehousebrandonfl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=573750987886990619&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sake-house",
      "poi_latitude": "27.9247923",
      "poi_longitude": "-82.29586929999999",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 813-684-3485",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fb0-7399-a89d-41bd9494868e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fb0-7399-a89d-41bd9494868e",
        "storage_key": "property/6767906449163357/019f14e2-7fb0-7399-a89d-41bd9494868e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJv21RVW3NwogRG5WIzntf9gc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "ec_3de4bccee05de8ef257debad",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "The Wooden Spoon Diner",
      "poi_type": "Restaurants",
      "poi_address": "865 Lithia Pinecrest Rd, Brandon, FL 33511, USA",
      "poi_short_description": "Unfussy, standard diner serving classic American breakfast & lunch staples such as eggs & biscuits.",
      "poi_long_description": "Unfussy, standard diner serving classic American breakfast & lunch staples such as eggs & biscuits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-76e3-76bc-ade6-7cbaada8aad4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-76e3-76bc-ade6-7cbaada8aad4",
        "storage_key": "property/6767906449163357/019f14e4-76e3-76bc-ade6-7cbaada8aad4.webp",
        "width": 1142,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/Thewoodenspoondiner",
      "poi_directions_map_url": "https://maps.google.com/?cid=5195457164080754528&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-wooden-spoon-diner",
      "poi_latitude": "27.9255773",
      "poi_longitude": "-82.2708432",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 813-655-5556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fb0-7399-a89d-41bd9494868e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fb0-7399-a89d-41bd9494868e",
        "storage_key": "property/6767906449163357/019f14e2-7fb0-7399-a89d-41bd9494868e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg_U5abvNwogRYK_KlsP4GUg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "ec_36fceca75c757f83c77e9bfe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Scooter's Coffee",
      "poi_type": "Restaurants",
      "poi_address": "402 W Brandon Blvd, Brandon, FL 33511, USA",
      "poi_short_description": "Drive-thru chain serving espresso & other coffee drinks, plus a variety of smoothies & pastries.",
      "poi_long_description": "Drive-thru chain serving espresso & other coffee drinks, plus a variety of smoothies & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-815f-73d3-ac75-8c7745f48090.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-815f-73d3-ac75-8c7745f48090",
        "storage_key": "property/6767906449163357/019f14e4-815f-73d3-ac75-8c7745f48090.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://scooterscoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13832346694285861760&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scooters-coffee",
      "poi_latitude": "27.9380633",
      "poi_longitude": "-82.2900102",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 813-662-4018",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e5-2640-746e-9f21-6587dbb20d8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-2640-746e-9f21-6587dbb20d8c",
        "storage_key": "property/6767906449163357/019f14e5-2640-746e-9f21-6587dbb20d8c.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJTbGkQWPNwogRgCP1Eghe9r8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_3a120caebb0cc026cd47ec0b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "11110 Causeway Blvd, Brandon, FL 33511, USA",
      "poi_short_description": "Chains store featuring groceries, electronics, and toys, as well as clothing, hardware, and pet supplies.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-90b4-728b-b2c7-8649bfbb9450.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-90b4-728b-b2c7-8649bfbb9450",
        "storage_key": "property/6767906449163357/019f14e4-90b4-728b-b2c7-8649bfbb9450.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walmart.com/store/2387-brandon-fl/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=9119061368538423384&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "27.9250411",
      "poi_longitude": "-82.3252182",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 813-661-4426",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7faa-7239-9995-46e4d2661aa1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7faa-7239-9995-46e4d2661aa1",
        "storage_key": "property/6767906449163357/019f14e2-7faa-7239-9995-46e4d2661aa1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJAXYAykHOwogRWGC49P9pjX4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_eaa0d7aef15cfcebe074ba28",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Publix Super Market at Lake Brandon Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "11255 Causeway Blvd, Brandon, FL 33511, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-9aba-765d-b246-d77dd88443e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-9aba-765d-b246-d77dd88443e3",
        "storage_key": "property/6767906449163357/019f14e4-9aba-765d-b246-d77dd88443e3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=663&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=11336367433810397238&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-lake-brandon-plaza",
      "poi_latitude": "27.921293",
      "poi_longitude": "-82.3237187",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 813-655-8911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e5-25ea-73c4-aa14-9805a81d946f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-25ea-73c4-aa14-9805a81d946f",
        "storage_key": "property/6767906449163357/019f14e5-25ea-73c4-aa14-9805a81d946f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDx3F-D_OwogRNkiTTx7eUp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_1ba1c2bebfdb73e51174f7b0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "10921 Causeway Blvd #358c, Brandon, FL 33511, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-904a-742f-a51e-b703110a54fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-904a-742f-a51e-b703110a54fc",
        "storage_key": "property/6767906449163357/019f14e4-904a-742f-a51e-b703110a54fc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/brandon-FL-358.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=1163236247037165142&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "27.92121",
      "poi_longitude": "-82.3312821",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 813-952-0103",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7faa-7239-9995-46e4d2661aa1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7faa-7239-9995-46e4d2661aa1",
        "storage_key": "property/6767906449163357/019f14e2-7faa-7239-9995-46e4d2661aa1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJLwC1mjjOwogRVj6CHjSlJBA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "ec_ba44a06f05396cec4f12c1f6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Sprouts",
      "poi_type": "Shopping & Retail",
      "poi_address": "11339 Causeway Blvd, Brandon, FL 33511, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-8eb6-75c1-90a5-6e89b3c5b702.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-8eb6-75c1-90a5-6e89b3c5b702",
        "storage_key": "property/6767906449163357/019f14e4-8eb6-75c1-90a5-6e89b3c5b702.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.sprouts.com/store/fl/brandon/635-brandon/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14729663253626967549&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sprouts",
      "poi_latitude": "27.9208182",
      "poi_longitude": "-82.32066290000002",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 813-725-1220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e5-25ea-73c4-aa14-9805a81d946f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-25ea-73c4-aa14-9805a81d946f",
        "storage_key": "property/6767906449163357/019f14e5-25ea-73c4-aa14-9805a81d946f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA80HahPPwogR_VWPJbBGasw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_7703e9466bfb75772e0cb3f3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "11210 Causeway Blvd, Brandon, FL 33511, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-a67e-7378-bf47-ee0dc715c9d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-a67e-7378-bf47-ee0dc715c9d6",
        "storage_key": "property/6767906449163357/019f14e4-a67e-7378-bf47-ee0dc715c9d6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/brandon/11210-causeway-blvd/2655867?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=7662171968007290024&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "27.9239137",
      "poi_longitude": "-82.3238011",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 813-651-9523",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e5-2630-736c-94db-197f7c759767.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-2630-736c-94db-197f7c759767",
        "storage_key": "property/6767906449163357/019f14e5-2630-736c-94db-197f7c759767.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ8ScwJEDOwogRqLwHGc-AVWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_a1dc2c1004701bd4c4287867",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "187 Brandon Town Center Dr, Brandon, FL 33511, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-a162-77e9-b773-0e054f114f9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-a162-77e9-b773-0e054f114f9e",
        "storage_key": "property/6767906449163357/019f14e4-a162-77e9-b773-0e054f114f9e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/brandon/812",
      "poi_directions_map_url": "https://maps.google.com/?cid=2926310461302056649&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "27.9360867",
      "poi_longitude": "-82.3233147",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 813-654-4955",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7faa-7239-9995-46e4d2661aa1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7faa-7239-9995-46e4d2661aa1",
        "storage_key": "property/6767906449163357/019f14e2-7faa-7239-9995-46e4d2661aa1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ874_eV3OwogRySZrPNxXnCg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_d93e7c4965f7bb1654f9a271",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Brandon Exchange",
      "poi_type": "Shopping & Retail",
      "poi_address": "459 Brandon Town Center Dr, Brandon, FL 33511, USA",
      "poi_short_description": "Familiar and trendy retailers include apparel, electronics, and jewelry chains, plus a food court.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-1506-74af-9495-58fd9efb0908.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-1506-74af-9495-58fd9efb0908",
        "storage_key": "property/6767906449163357/019f14e2-1506-74af-9495-58fd9efb0908.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://brandonexchange.com/?utm_source=google-business-profile&utm_medium=organic&utm_campaign=business-listing&utm_id=87377",
      "poi_directions_map_url": "https://maps.google.com/?cid=13355523094657287158&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brandon-exchange",
      "poi_latitude": "27.9321346",
      "poi_longitude": "-82.3258237",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 813-661-6255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7faa-7239-9995-46e4d2661aa1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7faa-7239-9995-46e4d2661aa1",
        "storage_key": "property/6767906449163357/019f14e2-7faa-7239-9995-46e4d2661aa1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQyZlfELOwogR9sOSdn5ZWLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_44665f4bfcd445c77e73a4d3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "620 E Brandon Blvd, Brandon, FL 33511, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-96d0-761c-af0e-e7fb123652b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-96d0-761c-af0e-e7fb123652b7",
        "storage_key": "property/6767906449163357/019f14e4-96d0-761c-af0e-e7fb123652b7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/fl/brandon/620-e-brandon-blvd/l696",
      "poi_directions_map_url": "https://maps.google.com/?cid=10525231858199399011&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "27.938545",
      "poi_longitude": "-82.276225",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e5-25ea-73c4-aa14-9805a81d946f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-25ea-73c4-aa14-9805a81d946f",
        "storage_key": "property/6767906449163357/019f14e5-25ea-73c4-aa14-9805a81d946f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyxoGRbTNwogRY4qZJpwiEZI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_c9738af747b86069cbb200d4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "930 Providence Rd, Brandon, FL 33511, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-a237-75ed-b087-13406b063447.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-a237-75ed-b087-13406b063447",
        "storage_key": "property/6767906449163357/019f14e4-a237-75ed-b087-13406b063447.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-930+providence+rd-brandon-fl-33511/id=4523",
      "poi_directions_map_url": "https://maps.google.com/?cid=3233229527213862117&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "27.9243316",
      "poi_longitude": "-82.3181115",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 813-684-7560",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fac-7478-a649-4cd6605acde5",
        "storage_key": "property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ58Y9gGzOwogR5ezi5h-93iw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_2a3689b1bf288ca743106ac2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "HomeGoods",
      "poi_type": "Shopping & Retail",
      "poi_address": "1945 W Lumsden Rd, Brandon, FL 33511, USA",
      "poi_short_description": "Home-decor chain stocking a variety of furnishings, bedding, kitchenware, holiday goods & more.",
      "poi_long_description": "Home-decor chain stocking a variety of furnishings, bedding, kitchenware, holiday goods & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-bcd3-7772-94b5-aa59c769d483.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-bcd3-7772-94b5-aa59c769d483",
        "storage_key": "property/6767906449163357/019f14e4-bcd3-7772-94b5-aa59c769d483.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.homegoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14004017344821776384&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "homegoods",
      "poi_latitude": "27.9216005",
      "poi_longitude": "-82.3164206",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 813-689-5076",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7faa-7239-9995-46e4d2661aa1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7faa-7239-9995-46e4d2661aa1",
        "storage_key": "property/6767906449163357/019f14e2-7faa-7239-9995-46e4d2661aa1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ9VQy4mzOwogRANCCIpRDWMI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_c6f3a1eb74a439a36a61623a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Brooker Elementary School",
      "poi_type": "Education",
      "poi_address": "812 Dewolf Rd, Brandon, FL 33511, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://brooker.mysdhc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14937830417763277519&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brooker-elementary-school",
      "poi_latitude": "27.9166926",
      "poi_longitude": "-82.2725875",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 813-744-8184",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fa9-750a-93e6-94c907ce46be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fa9-750a-93e6-94c907ce46be",
        "storage_key": "property/6767906449163357/019f14e2-7fa9-750a-93e6-94c907ce46be.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJy-jaNpbNwogRzxrO9Z7VTc8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_9eb5a8828d60424618a40fc9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Mintz Elementary School",
      "poi_type": "Education",
      "poi_address": "1510 Heather Lakes Blvd, Brandon, FL 33511, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.sdhc.k12.fl.us/schools/3061/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12793898661055537867&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mintz-elementary-school",
      "poi_latitude": "27.915104",
      "poi_longitude": "-82.3071389",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 813-744-8353",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fa9-750a-93e6-94c907ce46be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fa9-750a-93e6-94c907ce46be",
        "storage_key": "property/6767906449163357/019f14e2-7fa9-750a-93e6-94c907ce46be.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw66L_wvOwogRy6KPGAwPjbE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_30db3323f8a95afc3c1652a5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Giunta Middle School",
      "poi_type": "Education",
      "poi_address": "4202 S Falkenburg Rd, Riverview, FL 33569, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-a9af-71a7-8743-f8aa65a86dda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-a9af-71a7-8743-f8aa65a86dda",
        "storage_key": "property/6767906449163357/019f14e4-a9af-71a7-8743-f8aa65a86dda.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.hillsboroughschools.org/giunta",
      "poi_directions_map_url": "https://maps.google.com/?cid=754380304572703660&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "giunta-middle-school",
      "poi_latitude": "27.9101305",
      "poi_longitude": "-82.3573444",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 813-740-4888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fa9-750a-93e6-94c907ce46be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fa9-750a-93e6-94c907ce46be",
        "storage_key": "property/6767906449163357/019f14e2-7fa9-750a-93e6-94c907ce46be.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ84hOn9rPwogRrGOb3-MYeAo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_55a5281920b312f161116d62",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Burns Middle School",
      "poi_type": "Education",
      "poi_address": "615 Brooker Rd, Brandon, FL 33511, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://burns.mysdhc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7778342764876883849&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burns-middle-school",
      "poi_latitude": "27.9072637",
      "poi_longitude": "-82.2758942",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 813-744-8383",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fa9-750a-93e6-94c907ce46be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fa9-750a-93e6-94c907ce46be",
        "storage_key": "property/6767906449163357/019f14e2-7fa9-750a-93e6-94c907ce46be.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyYolfZLNwogRiWe3gYg58ms",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_eda2930736bac6868dc13172",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Spoto High School",
      "poi_type": "Education",
      "poi_address": "8538 Eagle Palm Dr, Riverview, FL 33578, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-b838-754c-af64-ca85f3b868d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-b838-754c-af64-ca85f3b868d6",
        "storage_key": "property/6767906449163357/019f14e4-b838-754c-af64-ca85f3b868d6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://spoto.mysdhc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14470988543478197451&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spoto-high-school",
      "poi_latitude": "27.8843853",
      "poi_longitude": "-82.353726",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 813-672-5405",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fa9-750a-93e6-94c907ce46be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fa9-750a-93e6-94c907ce46be",
        "storage_key": "property/6767906449163357/019f14e2-7fa9-750a-93e6-94c907ce46be.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuR-9EzHQwogRy-zD4mhH08g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_7ca460afb0dc82d98e014b38",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Brandon High School",
      "poi_type": "Education",
      "poi_address": "1101 Victoria St, Brandon, FL 33510, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-acca-715a-810e-9eb1b5112f85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-acca-715a-810e-9eb1b5112f85",
        "storage_key": "property/6767906449163357/019f14e4-acca-715a-810e-9eb1b5112f85.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "http://brandon.mysdhc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=429727397523324172&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brandon-high-school",
      "poi_latitude": "27.9440404",
      "poi_longitude": "-82.29972020000001",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 813-744-8120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fa9-750a-93e6-94c907ce46be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fa9-750a-93e6-94c907ce46be",
        "storage_key": "property/6767906449163357/019f14e2-7fa9-750a-93e6-94c907ce46be.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpSxU1yrMwogRDH2hj8qy9gU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_842af8985710005bcf28f0d0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Hillsborough College - Brandon Campus",
      "poi_type": "Education",
      "poi_address": "10451 Nancy Watkins Dr, Tampa, FL 33619, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-0ce0-72de-b125-5889ddb2f775.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-0ce0-72de-b125-5889ddb2f775",
        "storage_key": "property/6767906449163357/019f14e2-0ce0-72de-b125-5889ddb2f775.webp",
        "width": 333,
        "height": 333
      },
      "poi_business_url": "https://www.hccfl.edu/about-us/locations-and-directions/brandon-campus",
      "poi_directions_map_url": "https://maps.google.com/?cid=10376872202887724793&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hillsborough-college---brandon-campus",
      "poi_latitude": "27.9687388",
      "poi_longitude": "-82.3285617",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 813-253-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fa9-750a-93e6-94c907ce46be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fa9-750a-93e6-94c907ce46be",
        "storage_key": "property/6767906449163357/019f14e2-7fa9-750a-93e6-94c907ce46be.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc7rX88HOwogR-X6_HEoOApA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_79c349ce45a0c74d765d3780",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "First Discoveries Academy",
      "poi_type": "Education",
      "poi_address": "1311 Brooker Rd, Brandon, FL 33511, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-b93f-734c-b978-19c75e659621.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-b93f-734c-b978-19c75e659621",
        "storage_key": "property/6767906449163357/019f14e4-b93f-734c-b978-19c75e659621.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.firstdiscoveriesacademy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=705193851394001222&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "first-discoveries-academy",
      "poi_latitude": "27.9079876",
      "poi_longitude": "-82.26335019999999",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 813-662-9290",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fa9-750a-93e6-94c907ce46be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fa9-750a-93e6-94c907ce46be",
        "storage_key": "property/6767906449163357/019f14e2-7fa9-750a-93e6-94c907ce46be.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlTG0o5zNwogRRgkhUhJayQk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_ba74de89ba1cb6b940b24b10",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Academy of Brandon",
      "poi_type": "Education",
      "poi_address": "722 Lithia Pinecrest Rd, Brandon, FL 33511, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-bcd3-7772-94b5-adbcd0c92020.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-bcd3-7772-94b5-adbcd0c92020",
        "storage_key": "property/6767906449163357/019f14e4-bcd3-7772-94b5-adbcd0c92020.webp",
        "width": 480,
        "height": 640
      },
      "poi_business_url": "http://academyofbrandon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11725041512752287322&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "academy-of-brandon",
      "poi_latitude": "27.9269601",
      "poi_longitude": "-82.2742124",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 813-684-0028",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fa9-750a-93e6-94c907ce46be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fa9-750a-93e6-94c907ce46be",
        "storage_key": "property/6767906449163357/019f14e2-7fa9-750a-93e6-94c907ce46be.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFaF5udLNwogRWg5PSCK3t6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_f8d33d403a66458324c1d56a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Shining Stars Preschool Academy",
      "poi_type": "Education",
      "poi_address": "603 E Morgan St, Brandon, FL 33510, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-c356-70cc-8591-ebbe6e187d7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-c356-70cc-8591-ebbe6e187d7b",
        "storage_key": "property/6767906449163357/019f14e4-c356-70cc-8591-ebbe6e187d7b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://shiningstarspreschoolacademy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15411552337064801814&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shining-stars-preschool-academy",
      "poi_latitude": "27.9397987",
      "poi_longitude": "-82.2768337",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 813-661-6988",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fa9-750a-93e6-94c907ce46be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fa9-750a-93e6-94c907ce46be",
        "storage_key": "property/6767906449163357/019f14e2-7fa9-750a-93e6-94c907ce46be.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtytn-bTNwogRFrYWWDLV4NU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_fb86baf636cb8a7d70acb38c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "AMC The Regency 20",
      "poi_type": "Entertainment",
      "poi_address": "2496 W Brandon Blvd, Brandon, FL 33511, USA",
      "poi_short_description": "Clean chain showing new releases, plus a snacks menu and a bar.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-c2ff-773b-b762-4c3799de706e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-c2ff-773b-b762-4c3799de706e",
        "storage_key": "property/6767906449163357/019f14e4-c2ff-773b-b762-4c3799de706e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/tampa-st-petersburg/amc-the-regency-20?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=11007515201297907889&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-the-regency-20",
      "poi_latitude": "27.943217",
      "poi_longitude": "-82.324416",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 813-685-3396",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e5-25e3-779c-aba3-6012cc3a74cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-25e3-779c-aba3-6012cc3a74cf",
        "storage_key": "property/6767906449163357/019f14e5-25e3-779c-aba3-6012cc3a74cf.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1fQjTWfOwogRsQATWcGMwpg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_ea3b41e3859fb1a5adb2afa5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "O’Brien’s Irish Pub & Grill",
      "poi_type": "Entertainment",
      "poi_address": "701 W Lumsden Rd, Brandon, FL 33511, USA",
      "poi_short_description": "Colorful, convivial sports bar featuring a varied craft-beer list, Irish pub grub & live music.",
      "poi_long_description": "Colorful, convivial sports bar featuring a varied craft-beer list, Irish pub grub & live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-c637-72c9-8210-0bf150775ee8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-c637-72c9-8210-0bf150775ee8",
        "storage_key": "property/6767906449163357/019f14e4-c637-72c9-8210-0bf150775ee8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.obrienspubsbrandon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12718374032323341744&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "obriens-irish-pub--grill",
      "poi_latitude": "27.9217238",
      "poi_longitude": "-82.2948051",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 813-641-4512",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e5-2698-71b9-b4f9-63e43fe28d71.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-2698-71b9-b4f9-63e43fe28d71",
        "storage_key": "property/6767906449163357/019f14e5-2698-71b9-b4f9-63e43fe28d71.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyXHmwN3NwogRsG0vLcy9gLA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "irish_pub"
    },
    {
      "id": "ec_a1d832b4265f57525697f50f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Librandi’s Bar And Grill",
      "poi_type": "Entertainment",
      "poi_address": "1215 W Brandon Blvd, Brandon, FL 33511, USA",
      "poi_short_description": "Classic Irish eats highlight the menu at this welcoming gastropub with live music & drink specials.",
      "poi_long_description": "Classic Irish eats highlight the menu at this welcoming gastropub with live music & drink specials.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-be58-72ee-b1ad-f9f2111c2448.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-be58-72ee-b1ad-f9f2111c2448",
        "storage_key": "property/6767906449163357/019f14e4-be58-72ee-b1ad-f9f2111c2448.webp",
        "width": 606,
        "height": 599
      },
      "poi_business_url": "http://www.otoolesirishbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11763500679214713601&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "librandis-bar-and-grill",
      "poi_latitude": "27.9371575",
      "poi_longitude": "-82.3013367",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 813-684-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e5-2698-71b9-b4f9-63e43fe28d71.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-2698-71b9-b4f9-63e43fe28d71",
        "storage_key": "property/6767906449163357/019f14e5-2698-71b9-b4f9-63e43fe28d71.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQcaDBtbNwogRAcuow4pZQKM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "irish_pub"
    },
    {
      "id": "ec_520fe403a5f873b4c3a9750b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "The Noise Box",
      "poi_type": "Entertainment",
      "poi_address": "1310 John Moore Rd, Brandon, FL 33511, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-c0a2-769d-851c-a9441125cb5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-c0a2-769d-851c-a9441125cb5a",
        "storage_key": "property/6767906449163357/019f14e4-c0a2-769d-851c-a9441125cb5a.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://www.facebook.com/TheNoiseBoxDCN",
      "poi_directions_map_url": "https://maps.google.com/?cid=8567298066899374342&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-noise-box",
      "poi_latitude": "27.91957",
      "poi_longitude": "-82.28658779999999",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 813-431-5082",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fac-7478-a649-4cd6605acde5",
        "storage_key": "property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__-_4enNwogRBpFtSjMo5XY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_cd6fa731db8b2369b8cbadef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Moon Mountain",
      "poi_type": "Entertainment",
      "poi_address": "210 S Kings Ave # J, Brandon, FL 33511, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-cc68-72ad-bae6-663abc98e2cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-cc68-72ad-bae6-663abc98e2cb",
        "storage_key": "property/6767906449163357/019f14e4-cc68-72ad-bae6-663abc98e2cb.webp",
        "width": 1242,
        "height": 700
      },
      "poi_business_url": "https://moonmountain.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12269088607989573982&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "moon-mountain",
      "poi_latitude": "27.9348492",
      "poi_longitude": "-82.29427989999999",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 813-324-9153",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e5-2640-746e-9f21-6587dbb20d8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-2640-746e-9f21-6587dbb20d8c",
        "storage_key": "property/6767906449163357/019f14e5-2640-746e-9f21-6587dbb20d8c.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJuxEmA9HNwogRXqkCpRWPRKo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_c145a99154af79400711789e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Brandon Exchange",
      "poi_type": "Entertainment",
      "poi_address": "459 Brandon Town Center Dr, Brandon, FL 33511, USA",
      "poi_short_description": "Familiar and trendy retailers include apparel, electronics, and jewelry chains, plus a food court.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-1506-74af-9495-58fd9efb0908.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-1506-74af-9495-58fd9efb0908",
        "storage_key": "property/6767906449163357/019f14e2-1506-74af-9495-58fd9efb0908.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://brandonexchange.com/?utm_source=google-business-profile&utm_medium=organic&utm_campaign=business-listing&utm_id=87377",
      "poi_directions_map_url": "https://maps.google.com/?cid=13355523094657287158&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brandon-exchange",
      "poi_latitude": "27.9321346",
      "poi_longitude": "-82.3258237",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 813-661-6255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7faa-7239-9995-46e4d2661aa1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7faa-7239-9995-46e4d2661aa1",
        "storage_key": "property/6767906449163357/019f14e2-7faa-7239-9995-46e4d2661aa1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQyZlfELOwogR9sOSdn5ZWLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_8b52037a4543dbbc4ca8ca77",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Sparkman Wharf",
      "poi_type": "Entertainment",
      "poi_address": "615 Channelside Dr, Tampa, FL 33602, USA",
      "poi_short_description": "Modern waterfront area featuring hip restaurants & shops, a beer garden & street-food stands.",
      "poi_long_description": "Modern waterfront area featuring hip restaurants & shops, a beer garden & street-food stands.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-cd9f-72e0-b8a5-545d05422891.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-cd9f-72e0-b8a5-545d05422891",
        "storage_key": "property/6767906449163357/019f14e4-cd9f-72e0-b8a5-545d05422891.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sparkmanwharf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2298001502316238008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sparkman-wharf",
      "poi_latitude": "27.9433292",
      "poi_longitude": "-82.4476555",
      "poi_miles_from_property": "10.1 mi",
      "poi_walking_minutes": "3 hours 42 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 813-618-5844",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fac-7478-a649-4cd6605acde5",
        "storage_key": "property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD0N73GTFwogRuJTf5jAk5B8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "plaza"
    },
    {
      "id": "ec_e0bf9bb1ceceb84eacbd7f48",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "The Florida Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "701 Channelside Dr, Tampa, FL 33602, USA",
      "poi_short_description": "Aquarium with sharks, penguins, stingray touch tanks, a wild dolphin cruise & a water playground.",
      "poi_long_description": "Aquarium with sharks, penguins, stingray touch tanks, a wild dolphin cruise & a water playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-cda2-756e-937b-d88d529f1074.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-cda2-756e-937b-d88d529f1074",
        "storage_key": "property/6767906449163357/019f14e4-cda2-756e-937b-d88d529f1074.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.flaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15088866459868476301&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-florida-aquarium",
      "poi_latitude": "27.943972",
      "poi_longitude": "-82.44487470000001",
      "poi_miles_from_property": "10.0 mi",
      "poi_walking_minutes": "3 hours 40 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 813-273-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fac-7478-a649-4cd6605acde5",
        "storage_key": "property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCXAq5_DEwogRjTPE2xlsZtE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "ec_4a8196842af728a79852ecb8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Glazer Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "110 W Gasparilla Plaza, Tampa, FL 33602, USA",
      "poi_short_description": "Interactive activities focused on weather, art, communication & more for children under 12.",
      "poi_long_description": "Interactive activities focused on weather, art, communication & more for children under 12.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-d699-7119-b2f0-855950d30233.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-d699-7119-b2f0-855950d30233",
        "storage_key": "property/6767906449163357/019f14e4-d699-7119-b2f0-855950d30233.webp",
        "width": 1280,
        "height": 1080
      },
      "poi_business_url": "http://www.glazermuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14656511005827888982&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glazer-childrens-museum",
      "poi_latitude": "27.949577",
      "poi_longitude": "-82.461494",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 52 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 813-443-3861",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fc2-71f8-b542-4169d64861fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fc2-71f8-b542-4169d64861fd",
        "storage_key": "property/6767906449163357/019f14e2-7fc2-71f8-b542-4169d64861fd.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-6lKAInEwogRVnf5NBtjZss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_e36b25020950d56c4b887d29",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Straz Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "1010 N WC Macinnes Pl, Tampa, FL 33602, USA",
      "poi_short_description": "Spacious venue featuring a 4,327-seat space for dance, theater & opera performances.",
      "poi_long_description": "Spacious venue featuring a 4,327-seat space for dance, theater & opera performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-d64d-73f0-9165-2d73df819fe4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-d64d-73f0-9165-2d73df819fe4",
        "storage_key": "property/6767906449163357/019f14e4-d64d-73f0-9165-2d73df819fe4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.strazcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6331971547108004456&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "straz-center-for-the-performing-arts",
      "poi_latitude": "27.9516604",
      "poi_longitude": "-82.4640622",
      "poi_miles_from_property": "10.7 mi",
      "poi_walking_minutes": "3 hours 59 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 813-229-7827",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fac-7478-a649-4cd6605acde5",
        "storage_key": "property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJce6XFIjEwogRaNJA6ZKu31c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_dae6aadbb6a6f998ed4ba334",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "HCA Florida Brandon Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "119 Oakfield Dr, Brandon, FL 33511, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-4caa-7378-9ddc-b3ff7fb53aef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-4caa-7378-9ddc-b3ff7fb53aef",
        "storage_key": "property/6767906449163357/019f14e2-4caa-7378-9ddc-b3ff7fb53aef.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hcafloridahealthcare.com/locations/brandon-hospital/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=14446453729982351493&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-florida-brandon-hospital",
      "poi_latitude": "27.9326915",
      "poi_longitude": "-82.28744999999999",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 813-681-5551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fc2-71f8-b542-471ce94bf107.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fc2-71f8-b542-471ce94bf107",
        "storage_key": "property/6767906449163357/019f14e2-7fc2-71f8-b542-471ce94bf107.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJjwgtbc_NwogRhQi3dyAdfMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_e182b4a9a4d5a8ba89b069a2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "MD Now Urgent Care - Brandon",
      "poi_type": "Health and Wellness",
      "poi_address": "10943 Causeway Blvd, Brandon, FL 33511, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-cfe6-7220-b4b4-4a6aa2d792ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-cfe6-7220-b4b4-4a6aa2d792ca",
        "storage_key": "property/6767906449163357/019f14e4-cfe6-7220-b4b4-4a6aa2d792ca.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mymdnow.com/locations/hillsborough/brandon?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=455749061362774360&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "md-now-urgent-care---brandon",
      "poi_latitude": "27.9222045",
      "poi_longitude": "-82.32920949999999",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 813-688-9480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fac-7478-a649-4cd6605acde5",
        "storage_key": "property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa2v6KG3PwogRWPE-TVslUwY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_d12d2324e7466e42038cc883",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "TGH Urgent Care powered by Fast Track (Brandon)",
      "poi_type": "Health and Wellness",
      "poi_address": "799 W Lumsden Rd, Brandon, FL 33511, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-cfed-73c9-aa1c-f4112dcd0018.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-cfed-73c9-aa1c-f4112dcd0018",
        "storage_key": "property/6767906449163357/019f14e4-cfed-73c9-aa1c-f4112dcd0018.webp",
        "width": 680,
        "height": 382
      },
      "poi_business_url": "https://www.fasttrackurgentcare.com/locations-and-hours/brandon/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8580433514627816188&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tgh-urgent-care-powered-by-fast-track-brandon",
      "poi_latitude": "27.922678",
      "poi_longitude": "-82.2969504",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 813-925-1903",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fac-7478-a649-4cd6605acde5",
        "storage_key": "property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSy0ZWhvNwogR_Fo_CtLSE3c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_1d000f2960cba58326bd189d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "715 W Brandon Blvd, Brandon, FL 33511, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-cf28-706a-9b34-1c0524fb8e74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-cf28-706a-9b34-1c0524fb8e74",
        "storage_key": "property/6767906449163357/019f14e4-cf28-706a-9b34-1c0524fb8e74.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/brandon-fl-pharmacies/715-w-brandon-blvd-brandon-fl-33511/storeid=2825?WT.mc_id=LS_GOOGLE_RX_2825",
      "poi_directions_map_url": "https://maps.google.com/?cid=15530045409299743692&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "27.9371055",
      "poi_longitude": "-82.29441279999999",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 813-653-4109",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e5-263d-76bd-9212-6b7bc11514f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-263d-76bd-9212-6b7bc11514f8",
        "storage_key": "property/6767906449163357/019f14e5-263d-76bd-9212-6b7bc11514f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOQjgdrjNwogRzEP_ngTOhdc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_0775763e504ace7cc9ca60ff",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "128 E Brandon Blvd, Brandon, FL 33511, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-d2c2-7022-8fb2-11b1334ad5de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-d2c2-7022-8fb2-11b1334ad5de",
        "storage_key": "property/6767906449163357/019f14e4-d2c2-7022-8fb2-11b1334ad5de.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-128+e+brandon+blvd-brandon-fl-33511/id=4962",
      "poi_directions_map_url": "https://maps.google.com/?cid=11403795969934867595&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "27.9380452",
      "poi_longitude": "-82.28500369999999",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 813-689-4499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e5-263d-76bd-9212-6b7bc11514f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-263d-76bd-9212-6b7bc11514f8",
        "storage_key": "property/6767906449163357/019f14e5-263d-76bd-9212-6b7bc11514f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_6da8cvNwogRi7z_xgNsQp4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_2be83f7c77b72fef7495b238",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Publix Pharmacy at Bloomingdale Square",
      "poi_type": "Health and Wellness",
      "poi_address": "949 E Bloomingdale Ave, Brandon, FL 33511, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-d306-7661-906a-f2f12d66322d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-d306-7661-906a-f2f12d66322d",
        "storage_key": "property/6767906449163357/019f14e4-d306-7661-906a-f2f12d66322d.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "https://www.publix.com/pharmacy?utm_medium=maps&utm_source=google&utm_content=psmpharm_google_override",
      "poi_directions_map_url": "https://maps.google.com/?cid=5336593276007905264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-pharmacy-at-bloomingdale-square",
      "poi_latitude": "27.8910211",
      "poi_longitude": "-82.2701526",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 813-413-3150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e5-263d-76bd-9212-6b7bc11514f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-263d-76bd-9212-6b7bc11514f8",
        "storage_key": "property/6767906449163357/019f14e5-263d-76bd-9212-6b7bc11514f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP4IrG3fSwogR8HcwX09jD0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_3f033c452710a9833d03945f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2890 Providence Lakes Blvd, Brandon, FL 33511, USA",
      "poi_short_description": "Premium fitness club offering cardio and strength equipment, a pool, racquetball courts, and a sauna.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-481c-73a9-8610-c6a3eb4c0086.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-481c-73a9-8610-c6a3eb4c0086",
        "storage_key": "property/6767906449163357/019f14e2-481c-73a9-8610-c6a3eb4c0086.webp",
        "width": 1081,
        "height": 720
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=372&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=15585734669472571150&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "27.9208577",
      "poi_longitude": "-82.3289471",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 813-685-9160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fac-7478-a649-4cd6605acde5",
        "storage_key": "property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrRWGRz_OwogRDh9n6RqnS9g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_561990f2fc39305169b50ff4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "911 Lithia Pinecrest Rd, Brandon, FL 33511, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-3ffe-745e-a4ca-3b5fe6229538.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-3ffe-745e-a4ca-3b5fe6229538",
        "storage_key": "property/6767906449163357/019f14e2-3ffe-745e-a4ca-3b5fe6229538.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/brandon-fl?utm_medium=yext&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=11865258499848819964&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "27.9253777",
      "poi_longitude": "-82.27012649999999",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 352-624-7301",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fac-7478-a649-4cd6605acde5",
        "storage_key": "property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCcklsInNwogR_FSso73dqaQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_92962c6589657fe461e1cce9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Pure Barre",
      "poi_type": "Health and Wellness",
      "poi_address": "857 E Bloomingdale Ave Unit 807, Brandon, FL 33511, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-d816-70cc-8167-633afd1fe7c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-d816-70cc-8167-633afd1fe7c4",
        "storage_key": "property/6767906449163357/019f14e4-d816-70cc-8167-633afd1fe7c4.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.purebarre.com/location/brandon-fl",
      "poi_directions_map_url": "https://maps.google.com/?cid=12094001768704036626&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pure-barre",
      "poi_latitude": "27.8921382",
      "poi_longitude": "-82.2724284",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 813-601-4588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fac-7478-a649-4cd6605acde5",
        "storage_key": "property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_YOalnfSwogREs-MKIiG1qc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_d2678b084b5b4f1750a3b1c8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "The Yoga House - Brandon",
      "poi_type": "Health and Wellness",
      "poi_address": "505 Eichenfeld Dr Ste 106, Brandon, FL 33511, USA",
      "poi_short_description": "Yoga studio offering a variety of classes with lake views.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-e43e-708c-bfeb-aa9232653e80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-e43e-708c-bfeb-aa9232653e80",
        "storage_key": "property/6767906449163357/019f14e4-e43e-708c-bfeb-aa9232653e80.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.theyogahousebrandon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6971743172204589233&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-yoga-house---brandon",
      "poi_latitude": "27.9324145",
      "poi_longitude": "-82.2913477",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 813-763-2522",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fa9-750a-93e6-94c907ce46be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fa9-750a-93e6-94c907ce46be",
        "storage_key": "property/6767906449163357/019f14e2-7fa9-750a-93e6-94c907ce46be.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJiYj_D9DNwogRsXCCLHqbwGA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_c7381497465cca3fdbc23fcb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Bertha and Tony Saladino Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1705 Bryan Rd, Brandon, FL 33511, USA",
      "poi_short_description": "Community park with a baseball field, basketball courts, shaded walkways & an open lawn.",
      "poi_long_description": "Community park with a baseball field, basketball courts, shaded walkways & an open lawn.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-e8ad-742f-b70e-2ff1d3d45f25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-e8ad-742f-b70e-2ff1d3d45f25",
        "storage_key": "property/6767906449163357/019f14e4-e8ad-742f-b70e-2ff1d3d45f25.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hillsboroughcounty.org/en/locations/bertha-and-tony-saladino-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14969842860108854610&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bertha-and-tony-saladino-park",
      "poi_latitude": "27.91726",
      "poi_longitude": "-82.276432",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 813-744-5595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-800b-76af-bf2f-f4300002b9f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-800b-76af-bf2f-f4300002b9f1",
        "storage_key": "property/6767906449163357/019f14e2-800b-76af-bf2f-f4300002b9f1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-3SJu5XNwogRUrU0hMSQv88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_74bb963d2a4803f748330bb7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "All Person's Rotary Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "800 S Parsons Ave, Brandon, FL 33511, USA",
      "poi_short_description": "Green space with a universal, fenced-in playground & splash pad, plus a picnic pavilion & restrooms.",
      "poi_long_description": "Green space with a universal, fenced-in playground & splash pad, plus a picnic pavilion & restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7131-72ad-8d57-2f44eb77bd1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-7131-72ad-8d57-2f44eb77bd1d",
        "storage_key": "property/6767906449163357/019f14e2-7131-72ad-8d57-2f44eb77bd1d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.hillsboroughcounty.org/en/locations/all-persons-rotary-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13685765798743816238&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "all-persons-rotary-park",
      "poi_latitude": "27.9284411",
      "poi_longitude": "-82.2871612",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 813-744-5595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-800b-76af-bf2f-f4300002b9f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-800b-76af-bf2f-f4300002b9f1",
        "storage_key": "property/6767906449163357/019f14e2-800b-76af-bf2f-f4300002b9f1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKeglXMTNwogRLrhQ0Xub7b0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_0f4aed7938e19cb7ec82d421",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Paul Sanders Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "602 W Bloomingdale Ave, Brandon, FL 33511, USA",
      "poi_short_description": "Compact, leafy county park featuring a playground, sheltered picnic tables & walking trails.",
      "poi_long_description": "Compact, leafy county park featuring a playground, sheltered picnic tables & walking trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-63b7-77da-a095-1f8ae3bbc065.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-63b7-77da-a095-1f8ae3bbc065",
        "storage_key": "property/6767906449163357/019f14e2-63b7-77da-a095-1f8ae3bbc065.webp",
        "width": 1280,
        "height": 868
      },
      "poi_business_url": "http://www.hillsboroughcounty.org/en/locations/paul-sanders-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=8835322112529823101&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paul-sanders-park",
      "poi_latitude": "27.8942652",
      "poi_longitude": "-82.2931589",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 813-744-5595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-800b-76af-bf2f-f4300002b9f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-800b-76af-bf2f-f4300002b9f1",
        "storage_key": "property/6767906449163357/019f14e2-800b-76af-bf2f-f4300002b9f1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJc4hPrgfSwogRfXV-WaZenXo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_3f1ff4de2eddd024c608ac63",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Davis Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "612 N Parsons Ave, Brandon, FL 33510, USA",
      "poi_short_description": "Park with a playground, basketball courts, and picnic pavilions, plus restrooms.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-debe-748e-a764-60f61adcc927.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-debe-748e-a764-60f61adcc927",
        "storage_key": "property/6767906449163357/019f14e4-debe-748e-a764-60f61adcc927.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hillsboroughcounty.org/en/locations/davis-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6518865798837877412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "davis-park",
      "poi_latitude": "27.9486046",
      "poi_longitude": "-82.2866817",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 813-744-5595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-800b-76af-bf2f-f4300002b9f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-800b-76af-bf2f-f4300002b9f1",
        "storage_key": "property/6767906449163357/019f14e2-800b-76af-bf2f-f4300002b9f1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJC64A4TPMwogRpLos1uepd1o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_252a1444e08dbe80512cf163",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Bloomingdale West Park and Community Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3940 Canoga Park Dr, Brandon, FL 33511, USA",
      "poi_short_description": "Community park featuring tennis courts, handball walls and an outdoor basketball court.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-e9b6-7770-9eae-2691b30e6051.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-e9b6-7770-9eae-2691b30e6051",
        "storage_key": "property/6767906449163357/019f14e4-e9b6-7770-9eae-2691b30e6051.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hillsboroughcounty.org/en/locations/bloomingdale-west-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16740243439392814218&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bloomingdale-west-park-and-community-center",
      "poi_latitude": "27.882208",
      "poi_longitude": "-82.2733891",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 813-744-5595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-800b-76af-bf2f-f4300002b9f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-800b-76af-bf2f-f4300002b9f1",
        "storage_key": "property/6767906449163357/019f14e2-800b-76af-bf2f-f4300002b9f1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJd-zSdW7SwogRinSS6rZKUeg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_3135326bb1bd682bdd1aab34",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Limona Disc Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1315 Lakewood Dr, Brandon, FL 33510, USA",
      "poi_short_description": "Free, well-maintained disc golf course offering 18 tee pads for 9 baskets.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-f4af-759a-ab84-c9ea5686e9f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-f4af-759a-ab84-c9ea5686e9f5",
        "storage_key": "property/6767906449163357/019f14e4-f4af-759a-ab84-c9ea5686e9f5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.pdga.com/course-directory/course/limona-disc-golf-course",
      "poi_directions_map_url": "https://maps.google.com/?cid=4445417220027212401&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "limona-disc-golf-course",
      "poi_latitude": "27.960763",
      "poi_longitude": "-82.31017109999999",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 706-261-6342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fac-7478-a649-4cd6605acde5",
        "storage_key": "property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMf3HM5rOwogRcWIgpmhLsT0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "athletic_field"
    },
    {
      "id": "ec_23a4ccdda9d18ad4da4a29e7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Brandon Park & Recreation Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "502 E Sadie St, Brandon, FL 33510, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-5e3a-740e-8f39-99df746f5958.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-5e3a-740e-8f39-99df746f5958",
        "storage_key": "property/6767906449163357/019f14e2-5e3a-740e-8f39-99df746f5958.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hillsboroughcounty.org/en/locations/brandon-park-and-rec-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=6855191192757675859&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brandon-park--recreation-center",
      "poi_latitude": "27.9419442",
      "poi_longitude": "-82.28055979999999",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 813-635-8179",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-800b-76af-bf2f-f4300002b9f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-800b-76af-bf2f-f4300002b9f1",
        "storage_key": "property/6767906449163357/019f14e2-800b-76af-bf2f-f4300002b9f1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJw0jirsrNwogRUye1xxGIIl8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_7b248148e817996132d82cf9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "North Brandon Sports Complex",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3909 S Kingsway Rd, Seffner, FL 33584, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-e4a9-7009-adea-e61dd2e1f39f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-e4a9-7009-adea-e61dd2e1f39f",
        "storage_key": "property/6767906449163357/019f14e4-e4a9-7009-adea-e61dd2e1f39f.webp",
        "width": 1280,
        "height": 713
      },
      "poi_business_url": "https://www.hillsboroughcounty.org/en/locations/north-brandon-sports-complex",
      "poi_directions_map_url": "https://maps.google.com/?cid=11444251200914151739&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-brandon-sports-complex",
      "poi_latitude": "27.9683224",
      "poi_longitude": "-82.28028669999999",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 813-744-5595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fac-7478-a649-4cd6605acde5",
        "storage_key": "property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ_bOQNvNwogRO1nTPtUl0p4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "ec_f976f6e9928892cdf964da1f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Brandon Parkway Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Brandon Pkwy, Brandon, FL 33511, USA",
      "poi_short_description": "Park featuring walking and biking trails, and opportunities to observe wildlife.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-eed9-705e-90d8-9766d8ead4f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-eed9-705e-90d8-9766d8ead4f9",
        "storage_key": "property/6767906449163357/019f14e4-eed9-705e-90d8-9766d8ead4f9.webp",
        "width": 1280,
        "height": 829
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13209193928896148189&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brandon-parkway-trail",
      "poi_latitude": "27.9286422",
      "poi_longitude": "-82.3117346",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-800b-76af-bf2f-f4300002b9f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-800b-76af-bf2f-f4300002b9f1",
        "storage_key": "property/6767906449163357/019f14e2-800b-76af-bf2f-f4300002b9f1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJhzqr6nHOwogR3fIZneR7ULc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_98597bb73f9fbb903c9ba207",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Providence West Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5405 Providence Rd, Riverview, FL 33578, USA",
      "poi_short_description": "Spacious, clean outdoor park featuring several fields for games of basketball, football, and soccer.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-f253-71dd-bef9-3172ec689070.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-f253-71dd-bef9-3172ec689070",
        "storage_key": "property/6767906449163357/019f14e4-f253-71dd-bef9-3172ec689070.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hillsboroughcounty.org/en/locations/providence-west-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14515482127802196261&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-west-park",
      "poi_latitude": "27.8994599",
      "poi_longitude": "-82.3187092",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 813-744-5319",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-800b-76af-bf2f-f4300002b9f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-800b-76af-bf2f-f4300002b9f1",
        "storage_key": "property/6767906449163357/019f14e2-800b-76af-bf2f-f4300002b9f1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWffYbB7OwogRJWEuwxZacck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_795b78cbd5ecbda55a68101f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Brandon Exchange",
      "poi_type": "Transportation & Transit",
      "poi_address": "459 Brandon Town Center Dr, Brandon, FL 33511, USA",
      "poi_short_description": "Familiar and trendy retailers include apparel, electronics, and jewelry chains, plus a food court.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-1506-74af-9495-58fd9efb0908.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-1506-74af-9495-58fd9efb0908",
        "storage_key": "property/6767906449163357/019f14e2-1506-74af-9495-58fd9efb0908.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://brandonexchange.com/?utm_source=google-business-profile&utm_medium=organic&utm_campaign=business-listing&utm_id=87377",
      "poi_directions_map_url": "https://maps.google.com/?cid=13355523094657287158&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brandon-exchange",
      "poi_latitude": "27.9321346",
      "poi_longitude": "-82.3258237",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 813-661-6255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7faa-7239-9995-46e4d2661aa1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7faa-7239-9995-46e4d2661aa1",
        "storage_key": "property/6767906449163357/019f14e2-7faa-7239-9995-46e4d2661aa1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQyZlfELOwogR9sOSdn5ZWLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_c249e30db485a224b61d46a1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "J C Handly Park Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "3007 S Kings Ave, Brandon, FL 33511, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16187407109245965595&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "j-c-handly-park-park-and-ride",
      "poi_latitude": "27.8995159",
      "poi_longitude": "-82.2953881",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fac-7478-a649-4cd6605acde5",
        "storage_key": "property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc4cI3PjNwogRGxU9VQA5peA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_0f940799cd82ae9de4e9010c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Dover District Park",
      "poi_type": "Transportation & Transit",
      "poi_address": "2320 Gallagher Rd, Dover, FL 33527, USA",
      "poi_short_description": "District park, playground and trails encircling a lake and ponds, plus a basketball court and ball fields.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-fe63-7238-b389-bb2fb05e20d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-fe63-7238-b389-bb2fb05e20d6",
        "storage_key": "property/6767906449163357/019f14e4-fe63-7238-b389-bb2fb05e20d6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2490075147900165757&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dover-district-park",
      "poi_latitude": "27.9876561",
      "poi_longitude": "-82.2357653",
      "poi_miles_from_property": "10.0 mi",
      "poi_walking_minutes": "3 hours 41 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-800b-76af-bf2f-f4300002b9f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-800b-76af-bf2f-f4300002b9f1",
        "storage_key": "property/6767906449163357/019f14e2-800b-76af-bf2f-f4300002b9f1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUdl27V_LwogRfR6ebieGjiI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_f04ce8fc9514fb7bcbe95fd6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Hidden River Regional Park-n-Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tampa, FL 33637, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-f369-75bd-bf83-9f72864764bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-f369-75bd-bf83-9f72864764bc",
        "storage_key": "property/6767906449163357/019f14e4-f369-75bd-bf83-9f72864764bc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2609662882517269938&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hidden-river-regional-park-n-ride",
      "poi_latitude": "28.075001",
      "poi_longitude": "-82.360529",
      "poi_miles_from_property": "14.2 mi",
      "poi_walking_minutes": "5 hours 16 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fac-7478-a649-4cd6605acde5",
        "storage_key": "property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMS6VTDvIwogRsr32p5BiNyQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_15a477cfaa8ea55187f11752",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Marion Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "1211 N Marion St, Tampa, FL 33602, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-feda-7003-a2b0-784be30852c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e4-feda-7003-a2b0-784be30852c6",
        "storage_key": "property/6767906449163357/019f14e4-feda-7003-a2b0-784be30852c6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.gohart.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12356063461840094640&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marion-transit-center",
      "poi_latitude": "27.9551255",
      "poi_longitude": "-82.4584442",
      "poi_miles_from_property": "10.2 mi",
      "poi_walking_minutes": "3 hours 48 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 813-254-4278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e5-26ac-73c1-8d15-d82b3d5276ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-26ac-73c1-8d15-d82b3d5276ad",
        "storage_key": "property/6767906449163357/019f14e5-26ac-73c1-8d15-d82b3d5276ad.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7X6-i2HEwogRsIUp2UCOeas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "ec_6f2846ac5ab61416781ddfb1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Amtrak",
      "poi_type": "Transportation & Transit",
      "poi_address": "601 N Nebraska Ave, Tampa, FL 33602, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e5-025e-75bc-bebd-c5ebf9bc6b4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-025e-75bc-bebd-c5ebf9bc6b4d",
        "storage_key": "property/6767906449163357/019f14e5-025e-75bc-bebd-c5ebf9bc6b4d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.amtrak.com/stations/tpa",
      "poi_directions_map_url": "https://maps.google.com/?cid=11680206783434409790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amtrak",
      "poi_latitude": "27.9526866",
      "poi_longitude": "-82.45065249999999",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 34 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 833-844-0830",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fac-7478-a649-4cd6605acde5",
        "storage_key": "property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXWlYhl_EwogRPke3ZS9uGKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_eff916e6e3e57a4936445f2a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Tampa International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "4100 George J. Bean Pkwy, Tampa, FL 33607, USA",
      "poi_short_description": "Large airport with free WiFi, an on-site hotel & many offshoots of popular Tampa restaurants.",
      "poi_long_description": "Large airport with free WiFi, an on-site hotel & many offshoots of popular Tampa restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e5-04f6-77de-bca7-0b8fcf305632.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-04f6-77de-bca7-0b8fcf305632",
        "storage_key": "property/6767906449163357/019f14e5-04f6-77de-bca7-0b8fcf305632.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tampaairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8816785868724491529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tampa-international-airport",
      "poi_latitude": "27.9768646",
      "poi_longitude": "-82.5302804",
      "poi_miles_from_property": "15.2 mi",
      "poi_walking_minutes": "5 hours 40 mins",
      "poi_biking_minutes": "1 hour 40 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 813-870-8700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e5-2698-71b9-b4f9-5c4c37df28e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-2698-71b9-b4f9-5c4c37df28e2",
        "storage_key": "property/6767906449163357/019f14e5-2698-71b9-b4f9-5c4c37df28e2.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ0Sek0bCwogRCdUBxgiEW3o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_afb2d96f7b86d5e7ab642b29",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Northwest Transfer Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "8951 W Waters Ave, Tampa, FL 33615, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e5-044b-7519-989c-8918498db018.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-044b-7519-989c-8918498db018",
        "storage_key": "property/6767906449163357/019f14e5-044b-7519-989c-8918498db018.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16322407467610345592&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-transfer-center",
      "poi_latitude": "28.0277315",
      "poi_longitude": "-82.5856912",
      "poi_miles_from_property": "21.5 mi",
      "poi_walking_minutes": "7 hours 59 mins",
      "poi_biking_minutes": "2 hours 5 mins",
      "poi_driving_minutes": "34 mins",
      "poi_business_phone": "+1 813-254-4278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e5-26ab-7477-ba6f-d8924a1cf428.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e5-26ab-7477-ba6f-d8924a1cf428",
        "storage_key": "property/6767906449163357/019f14e5-26ab-7477-ba6f-d8924a1cf428.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJA_5hoj_qwogReBAZqhzXhOI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "ec_a4aa6e4200696a2848b52d91",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "HCA Florida Brandon Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "119 Oakfield Dr, Brandon, FL 33511, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-4caa-7378-9ddc-b3ff7fb53aef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e2-4caa-7378-9ddc-b3ff7fb53aef",
        "storage_key": "property/6767906449163357/019f14e2-4caa-7378-9ddc-b3ff7fb53aef.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hcafloridahealthcare.com/locations/brandon-hospital/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=14446453729982351493&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-florida-brandon-hospital",
      "poi_latitude": "27.9326915",
      "poi_longitude": "-82.28744999999999",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 813-681-5551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fc2-71f8-b542-471ce94bf107.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fc2-71f8-b542-471ce94bf107",
        "storage_key": "property/6767906449163357/019f14e2-7fc2-71f8-b542-471ce94bf107.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJjwgtbc_NwogRhQi3dyAdfMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_9978bbd3c91422016d0d3831",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "AdventHealth Brandon ER",
      "poi_type": "Major Employers & Offices",
      "poi_address": "305 E Brandon Blvd, Brandon, FL 33511, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e5-049d-7659-b31c-cdf82b35c253.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-049d-7659-b31c-cdf82b35c253",
        "storage_key": "property/6767906449163357/019f14e5-049d-7659-b31c-cdf82b35c253.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.adventhealth.com/hospital-and-emergency-rooms/adventhealth-brandon-er",
      "poi_directions_map_url": "https://maps.google.com/?cid=15281277548863793558&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventhealth-brandon-er",
      "poi_latitude": "27.937258",
      "poi_longitude": "-82.2828059",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 813-548-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fac-7478-a649-4cd6605acde5",
        "storage_key": "property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh4UkowfNwogRlqktjvcAEtQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_478b201fe22fae2e981785a5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Brandon Regional Service Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "311 Pauls Dr, Brandon, FL 33511, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e5-0a28-7742-8cb9-04e5b9d6d485.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-0a28-7742-8cb9-04e5b9d6d485",
        "storage_key": "property/6767906449163357/019f14e5-0a28-7742-8cb9-04e5b9d6d485.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.hillsclerk.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15838041400749244844&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brandon-regional-service-center",
      "poi_latitude": "27.9329683",
      "poi_longitude": "-82.301688",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 813-276-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fcc-73d9-b7c2-9e9665f0994f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fcc-73d9-b7c2-9e9665f0994f",
        "storage_key": "property/6767906449163357/019f14e2-7fcc-73d9-b7c2-9e9665f0994f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh-S3v17OwogRrMGWjb0GzNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_d63f32d58c22944aa92ce1d0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Amazon (Ruskin FL) TPA1",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Amazon Fullfillment Center TPA1, 3350 Laurel Ridge Ave, Ruskin, FL 33570, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e5-0702-70ee-8b56-5a0609fbd249.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-0702-70ee-8b56-5a0609fbd249",
        "storage_key": "property/6767906449163357/019f14e5-0702-70ee-8b56-5a0609fbd249.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.amazon.jobs/en/locations/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12684158101651019108&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amazon-ruskin-fl-tpa1",
      "poi_latitude": "27.7278665",
      "poi_longitude": "-82.3883967",
      "poi_miles_from_property": "16.8 mi",
      "poi_walking_minutes": "6 hours 9 mins",
      "poi_biking_minutes": "1 hour 24 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 866-203-8361",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fac-7478-a649-4cd6605acde5",
        "storage_key": "property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8-BGKx3YwogRZFXNA5cuB7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "ec_9961900d31a04d2ee639e09e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "MacDill Air Force Base",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9211 Marina Bay Dr, Tampa, FL 33621, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e5-0c10-77bb-b0e1-cf2392f67a8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-0c10-77bb-b0e1-cf2392f67a8d",
        "storage_key": "property/6767906449163357/019f14e5-0c10-77bb-b0e1-cf2392f67a8d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.macdill.af.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7484022034244996361&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "macdill-air-force-base",
      "poi_latitude": "27.8498222",
      "poi_longitude": "-82.5089634",
      "poi_miles_from_property": "21.2 mi",
      "poi_walking_minutes": "7 hours 43 mins",
      "poi_biking_minutes": "1 hour 58 mins",
      "poi_driving_minutes": "36 mins",
      "poi_business_phone": "+1 813-828-1110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fcc-73d9-b7c2-9e9665f0994f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fcc-73d9-b7c2-9e9665f0994f",
        "storage_key": "property/6767906449163357/019f14e2-7fcc-73d9-b7c2-9e9665f0994f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmZP7nxLcwogRCY1eWmOW3Gc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_1b03d169d50844311da67fd7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "University of South Florida",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4202 E Fowler Ave, Tampa, FL 33620, USA",
      "poi_short_description": "Research university founded in 1956 with a variety of student organizations & Greek system houses.",
      "poi_long_description": "Research university founded in 1956 with a variety of student organizations & Greek system houses.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e5-1338-7248-9d06-421b5ecc4a8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-1338-7248-9d06-421b5ecc4a8f",
        "storage_key": "property/6767906449163357/019f14e5-1338-7248-9d06-421b5ecc4a8f.webp",
        "width": 1280,
        "height": 844
      },
      "poi_business_url": "https://www.usf.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12823001712777334890&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-south-florida",
      "poi_latitude": "28.0622334",
      "poi_longitude": "-82.4135057",
      "poi_miles_from_property": "15.0 mi",
      "poi_walking_minutes": "5 hours 34 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 813-974-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fa9-750a-93e6-94c907ce46be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fa9-750a-93e6-94c907ce46be",
        "storage_key": "property/6767906449163357/019f14e2-7fa9-750a-93e6-94c907ce46be.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0__Gw77HwogRapBRXB509LE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_85f96db823dfc1382b756fe9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Moffitt Magnolia Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "12920 USF Magnolia Drive, Tampa, FL 33612, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e5-11f4-777a-95d3-3d34019bd77e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-11f4-777a-95d3-3d34019bd77e",
        "storage_key": "property/6767906449163357/019f14e5-11f4-777a-95d3-3d34019bd77e.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://moffitt.org/locations-directions/moffitt-cancer-center-on-magnolia-usf/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2336389287961145418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "moffitt-magnolia-campus",
      "poi_latitude": "28.0641043",
      "poi_longitude": "-82.4210208",
      "poi_miles_from_property": "15.2 mi",
      "poi_walking_minutes": "5 hours 41 mins",
      "poi_biking_minutes": "1 hour 24 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 888-663-3488",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fac-7478-a649-4cd6605acde5",
        "storage_key": "property/6767906449163357/019f14e2-7fac-7478-a649-4cd6605acde5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFZTF16LHwogRSrDzva2FbCA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_1234b881a573a5acb6c1224d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Tampa General Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Tampa General Cir, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e5-14b0-7097-8d09-3551750c6d6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-14b0-7097-8d09-3551750c6d6d",
        "storage_key": "property/6767906449163357/019f14e5-14b0-7097-8d09-3551750c6d6d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tgh.org/?utm_source=ExtNet&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=13864056167954562457&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tampa-general-hospital",
      "poi_latitude": "27.9377069",
      "poi_longitude": "-82.45921299999999",
      "poi_miles_from_property": "11.3 mi",
      "poi_walking_minutes": "4 hours 9 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 813-844-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fc2-71f8-b542-471ce94bf107.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fc2-71f8-b542-471ce94bf107",
        "storage_key": "property/6767906449163357/019f14e2-7fc2-71f8-b542-471ce94bf107.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJW92V1ZPEwogRmb3-PKEFZ8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_7c9a0d7c1b96c9b1f5bb900e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "James A. Haley Veterans' Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "13000 Bruce B Downs Blvd, Tampa, FL 33612, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e5-1640-7041-aa29-89f277708bfb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-1640-7041-aa29-89f277708bfb",
        "storage_key": "property/6767906449163357/019f14e5-1640-7041-aa29-89f277708bfb.webp",
        "width": 1280,
        "height": 1117
      },
      "poi_business_url": "https://www.va.gov/tampa-health-care/locations/james-a-haley-veterans-hospital/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5577032833284040040&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "james-a-haley-veterans-hospital",
      "poi_latitude": "28.0644878",
      "poi_longitude": "-82.42916489999999",
      "poi_miles_from_property": "15.7 mi",
      "poi_walking_minutes": "5 hours 52 mins",
      "poi_biking_minutes": "1 hour 28 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 813-972-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fcc-73d9-b7c2-9e9665f0994f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fcc-73d9-b7c2-9e9665f0994f",
        "storage_key": "property/6767906449163357/019f14e2-7fcc-73d9-b7c2-9e9665f0994f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7ZIwdaHHwogRaOWVQNCZZU0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_68c32569100f8f2da91a8034",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "generator",
      "poi_name": "Hillsborough County Tax Collector",
      "poi_type": "Major Employers & Offices",
      "poi_address": "601 E Kennedy Blvd, Tampa, FL 33602, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e5-1509-770d-8d4c-a85dbebd8892.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e5-1509-770d-8d4c-a85dbebd8892",
        "storage_key": "property/6767906449163357/019f14e5-1509-770d-8d4c-a85dbebd8892.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hillstaxfl.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2993346978512072366&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hillsborough-county-tax-collector",
      "poi_latitude": "27.948334",
      "poi_longitude": "-82.45476599999999",
      "poi_miles_from_property": "10.1 mi",
      "poi_walking_minutes": "3 hours 44 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 813-635-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e2-7fcc-73d9-b7c2-9e9665f0994f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e2-7fcc-73d9-b7c2-9e9665f0994f",
        "storage_key": "property/6767906449163357/019f14e2-7fcc-73d9-b7c2-9e9665f0994f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRbrlKovEwogRrm6zrzeBiik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_cacdfa1f-a4e8-4f8d-8b24-2d92b57b3792",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_0cd0a561-8468-4a79-b158-fb1d4dab9ae1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_fc9d709e-b378-438f-bbc8-685ee7a71072",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_e76c1cd8-c54f-4d8c-89be-86f8ee0a079e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_01514727-c279-4cca-8c83-812162816c0e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_ec69e131-70cd-4fef-b046-ff41da18a904",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_14cac1094c27de2008f57678",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "rating": "5",
      "name": "Katie L",
      "text": "Absolutely beautiful apartments with a wonderful team of people! Tanaja has been so helpful throughout my move-in process, and Olivia is always quick to answer my questions and get any issues resolved. The unit had a couple small problems when I first moved in that maintenance had fixed in less than 24 hours. There are numerous amenities at The Griffin, including regular scheduled events like food trucks and art classes hosted by an on-site instructor. Overall, the atmosphere here is bright and refreshing and I can’t recommend it enough!",
      "date": "2026-02-11",
      "title": "false"
    },
    {
      "id": "ec_e62d3f420468c946d33d38a2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "rating": "5",
      "name": "Karl & Christine D",
      "text": "Our move-in experience at The Griffin has been absolutely phenomenal, and I want to personally recognize Tristin, the Community Manager, along with the entire office staff and maintenance team for their outstanding service.\n\nFrom the very beginning, Tristin and the office team made the entire process smooth, organized, and stress-free. Moving can be overwhelming, but they ensured everything was clearly communicated and handled with professionalism and care. Every interaction with the office team has been welcoming, helpful, and efficient.\n\nI also want to give a huge thank you to the maintenance team. Shortly after move-in, we had a few small items that needed attention, and their response was incredibly fast. They came by promptly, addressed the issues right away, and made sure everything was taken care of properly. Their professionalism, responsiveness, and attention to detail truly stood out.\n\nIt’s clear that the team at The Griffin takes pride in what they do and genuinely cares about their residents. The level of service we received from both the office staff and maintenance team has exceeded our expectations.\n\nThank you again to Tristin and the entire Griffin team for making our move-in experience so welcoming and seamless. We truly appreciate the effort and dedication from everyone involved.",
      "date": "2026-03-06",
      "title": "false"
    },
    {
      "id": "ec_5e3d1547ec254995b5b00bf9",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "rating": "4",
      "name": "Brandi Kelly",
      "text": "Update to Review: This place has undergone DRAMATIC changes. As a full paying member, it was frustrating to go through such an INTENSE remodel (inside and out)  for the last 6 months, but I would like to give a lot of credit to this management staff for making the changes necessary for us to live in a better community.\n\nThis place has been upgraded in our apartments, exterior painted, new outdoor seating in the pool and courtyard, new paved roads and signage, replenished the landscaping, etc.\n\nThe only reason I placed it at a 4 is the gates not closing but the property has placed an on-call sheriff on property that has provided us more security and I believe they are working to get the gates repaired.\n\nThis place is a must see now and you will not regret living here. They do care.\n\nBottom Line upfront: very dark in most places because they haven't done anything with the lighting. Not a safe feeling. The management team has NO idea what is going on with this property because they do not walk it. It's a MESS!\nThis property has been under three property managers in 12 months. I re-uped because I was told the new team was a full team of experienced professionals. Yes American Landmark (new owner as of Sept), has put money into this place, however they put money into what was good for the \"online. Photos\". Hundred plus thousand dollars went into a new front office that was beautiful before btw. New chairs and umbrellas were placed out by the pool (it's too cold to swim in November.\nThere is trash EVERYWHERE! The property managers have been contacted with replies the \"screens are staying put\" ** we have been living like this for 2 months. There is no checking up with the contractors. Contractors leave EVERY station a mess every day.\n\nOur court yard used to have a beautiful fire pit with Adirondack chairs and it was exchanged for a huge dead plant. Again, no lighting in the courtyard which is what is used to check mail and take out trash.\n\nDon't be fooled by what you see upfront, walk the property before signing a contract!!\nI would not move here and I will NOT be staying here.",
      "date": "2025-05-16",
      "title": "false"
    },
    {
      "id": "ec_43c0d2323b323f053b6d6fdf",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "rating": "5",
      "name": "Toney Williams",
      "text": "Just signed my 2nd lease and I’m loving it. The staff is amazing and the maintenance really does a great job. Particularly Barry he has a great attitude and goes above & beyond to ensure our comfort in our home.",
      "date": "2026-06-01",
      "title": "false"
    },
    {
      "id": "ec_e9602ba119945981029b8bd6",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "rating": "5",
      "name": "Amy McKinney",
      "text": "Tony, Barry and Brandon are an amazing maintenance crew! They literally took care of several work orders the same day they were submitted! It is great to know that requests are made a priority! Thanks to the crew!",
      "date": "2026-06-02",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_0997953e-762e-4675-b669-8c138be12a69",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019d02f6-0eb0-74fc-aafd-675d8d84dcf8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern open-concept living and dining area with a breakfast bar.",
        "public_id": "019d02f6-0eb0-74fc-aafd-675d8d84dcf8",
        "storage_key": "property/6767906449163357/019d02f6-0eb0-74fc-aafd-675d8d84dcf8.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "2BR, 2BA - 1,113SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=SSagZGzMQdw"
    },
    {
      "id": "custom_429d82ad-5dda-4c12-9565-58f1abcb63b9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019d02f6-0fbe-7739-8f25-eee75fb2f6fe.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a dining area.",
        "public_id": "019d02f6-0fbe-7739-8f25-eee75fb2f6fe",
        "storage_key": "property/6767906449163357/019d02f6-0fbe-7739-8f25-eee75fb2f6fe.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "2BR, 2BA - 1,143SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Btbc9sPg8wz"
    },
    {
      "id": "custom_77c69d87-fb3c-4172-b4a2-87b6d0e0b3eb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14c2-d545-769b-9741-24217b4ac335.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c2-d545-769b-9741-24217b4ac335",
        "storage_key": "property/6767906449163357/019f14c2-d545-769b-9741-24217b4ac335.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "The Griffin | Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/4KFPnypLy7o"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa46-b718-73c3-a23a-9a60de22983c",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "the-griffin",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357"
    },
    {
      "lead_collector_id": "0198aa46-b77b-7403-b0cd-d8a8f8e760b8",
      "lead_source": "FACEBOOK_ADS",
      "name": "the-griffin",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357"
    },
    {
      "lead_collector_id": "0198aa46-b7dd-736f-a786-14d6d1bd7eee",
      "lead_source": "LANDING_PAGE",
      "name": "the-griffin",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "one-bedroom-for-rent-in-brandon-fl-at-the-griffin",
      "search_query": "One Bedroom For Rent In Brandon FL",
      "category": "Floorplan",
      "h1_title": "One Bedroom For Rent In Brandon FL at The Griffin",
      "h2_subtitle": "Discover the perfect one-bedroom apartment at The Griffin in Brandon, FL. Enjoy modern amenities and a convenient location for a comfortable lifestyle.",
      "page_copy": "Looking for a one bedroom for rent in Brandon FL? The Griffin offers premium living with features like sleek granite or quartz countertops, in-home washer and dryer, and generous closet space. Each apartment includes screened-in private patios or balconies, perfect for relaxing. Enjoy modern lighting and plumbing fixtures, wood-style flooring, and smart home features that make life easier. Located at 1131 Courtney Trace Drive, The Griffin is your ideal home in Brandon, FL.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
      "blank_image_media": {
        "alt_text": "Community pool area with lounge chairs and umbrellas.",
        "public_id": "019f6c12-a13e-7597-a3cd-542b79a75f5d",
        "storage_key": "property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Griffin | One Bedroom For Rent In Brandon FL",
      "seo_description": "Find a one bedroom for rent in Brandon FL at The Griffin. Enjoy modern amenities and a convenient location at 1131 Courtney Trace Drive, Brandon, FL 33511.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "two-bedrooms-for-rent-in-brandon-fl-at-the-griffin",
      "search_query": "Two Bedrooms For Rent In Brandon FL",
      "category": "Floorplan",
      "h1_title": "Two Bedrooms For Rent In Brandon FL at The Griffin",
      "h2_subtitle": "Experience spacious living with our two-bedroom apartments at The Griffin in Brandon, FL. Enjoy top-notch amenities and a prime location for your convenience.",
      "page_copy": "Searching for two bedrooms for rent in Brandon FL? The Griffin provides spacious and modern two-bedroom apartments with features like sleek granite or quartz countertops, in-home washer and dryer, and generous closet space. Each unit includes screened-in private patios or balconies, perfect for enjoying the Florida weather. With modern lighting and plumbing fixtures, wood-style flooring, and smart home features, The Griffin ensures a comfortable and stylish living experience. Located at 1131 Courtney Trace Drive, The Griffin is the perfect place to call home in Brandon, FL.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
      "blank_image_media": {
        "alt_text": "Community pool area with lounge chairs and umbrellas.",
        "public_id": "019f6c12-a13e-7597-a3cd-542b79a75f5d",
        "storage_key": "property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Griffin | Two Bedrooms For Rent In Brandon FL",
      "seo_description": "Find two bedrooms for rent in Brandon FL at The Griffin. Enjoy spacious living with modern amenities at 1131 Courtney Trace Drive, Brandon, FL 33511.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "three-bedrooms-for-rent-in-brandon-fl-at-the-griffin",
      "search_query": "Three Bedrooms For Rent In Brandon FL",
      "category": "Floorplan",
      "h1_title": "Three Bedrooms For Rent In Brandon FL at The Griffin",
      "h2_subtitle": "Find your ideal three-bedroom apartment at The Griffin in Brandon, FL. Enjoy spacious living with modern amenities and a convenient location.",
      "page_copy": "Looking for three bedrooms for rent in Brandon FL? The Griffin offers spacious three-bedroom apartments with premium features like sleek granite or quartz countertops, in-home washer and dryer, and generous closet space. Each apartment includes screened-in private patios or balconies, perfect for relaxing and enjoying the outdoors. With modern lighting and plumbing fixtures, wood-style flooring, and smart home features, The Griffin provides a comfortable and stylish living experience. Located at 1131 Courtney Trace Drive, The Griffin is the perfect place to call home in Brandon, FL.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
      "blank_image_media": {
        "alt_text": "Community pool area with lounge chairs and umbrellas.",
        "public_id": "019f6c12-a13e-7597-a3cd-542b79a75f5d",
        "storage_key": "property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Griffin | Three Bedrooms For Rent In Brandon FL",
      "seo_description": "Find three bedrooms for rent in Brandon FL at The Griffin. Enjoy spacious living with modern amenities at 1131 Courtney Trace Drive, Brandon, FL 33511.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "for-rent-near-me-two-resort-inspired-pools-the-griffin",
      "search_query": "Apartments For Rent With Pools ",
      "category": "Amenity",
      "h1_title": "For Rent Near Me with Two Resort-Inspired Pools at The Griffin",
      "h2_subtitle": "Discover luxurious living at The Griffin in Brandon, FL. Enjoy top-notch amenities including two resort-inspired pools and a variety of community features.",
      "page_copy": "Searching for apartments for rent near me with two resort-inspired pools? The Griffin in Brandon, FL offers a luxurious living experience with community amenities like two resort-inspired pools, two fitness centers, and a clubhouse with a resident lounge. Our community also features a leash-free bark park, outdoor community grilling areas, and a 24-hour concierge package system. Located at 1131 Courtney Trace Drive, The Griffin provides convenient living with valet trash services, garages available, and concierge cleaning services. Choose from our one, two, or three-bedroom floor plans and enjoy the best of Brandon, FL.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
      "blank_image_media": {
        "alt_text": "Community pool area with lounge chairs and umbrellas.",
        "public_id": "019f6c12-a13e-7597-a3cd-542b79a75f5d",
        "storage_key": "property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Griffin | For Rent Near Me with Two Resort-Inspired Pools",
      "seo_description": "Find apartments for rent near me with two resort-inspired pools at The Griffin. Enjoy luxurious amenities and convenient living at 1131 Courtney Trace Drive, Brandon, FL 33511.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "for-rent-near-me-two-fitness-centers-the-griffin",
      "search_query": "Apartments For Rent Near Me with Two Fitness Centers",
      "category": "Amenity",
      "h1_title": "For Rent Near Me with Two Fitness Centers at The Griffin",
      "h2_subtitle": "Experience premium living at The Griffin in Brandon, FL. Enjoy top-tier amenities including two fitness centers and a variety of community features.",
      "page_copy": "Looking for apartments for rent near me with two fitness centers? The Griffin in Brandon, FL offers a premium living experience with community amenities like two fitness centers, two resort-inspired pools, and a clubhouse with a resident lounge. Our community also features a leash-free bark park, outdoor community grilling areas, and a 24-hour concierge package system. Located at 1131 Courtney Trace Drive, The Griffin provides convenient living with valet trash services, garages available, and concierge cleaning services. Choose from our one, two, or three-bedroom floor plans and enjoy the best of Brandon, FL.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
      "blank_image_media": {
        "alt_text": "Community pool area with lounge chairs and umbrellas.",
        "public_id": "019f6c12-a13e-7597-a3cd-542b79a75f5d",
        "storage_key": "property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Griffin | For Rent Near Me with Two Fitness Centers",
      "seo_description": "Find apartments for rent near me with two fitness centers at The Griffin. Enjoy luxurious amenities and convenient living at 1131 Courtney Trace Drive, Brandon, FL 33511.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "for-rent-near-me-clubhouse-resident-lounge-griffin",
      "search_query": "Homes For Rent Near Me with Clubhouse and Resident Lounge",
      "category": "Amenity",
      "h1_title": "Homes For Rent Near Me with Clubhouse ",
      "h2_subtitle": "Enjoy luxurious living at The Griffin in Brandon, FL. Our community features a clubhouse with a resident lounge and a variety of top-notch amenities.",
      "page_copy": "Searching for apartments for rent near me with a clubhouse w/resident lounge? The Griffin in Brandon, FL offers a luxurious living experience with community amenities like a clubhouse with a resident lounge, two resort-inspired pools, and two fitness centers. Our community also features a leash-free bark park, outdoor community grilling areas, and a 24-hour concierge package system. Located at 1131 Courtney Trace Drive, The Griffin provides convenient living with valet trash services, garages available, and concierge cleaning services. Choose from our one, two, or three-bedroom floor plans and enjoy the best of Brandon, FL.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
      "blank_image_media": {
        "alt_text": "Community pool area with lounge chairs and umbrellas.",
        "public_id": "019f6c12-a13e-7597-a3cd-542b79a75f5d",
        "storage_key": "property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Griffin | For Rent Near Me with Clubhouse w/Resident Lounge",
      "seo_description": "Find apartments for rent near me with a clubhouse w/resident lounge at The Griffin. Enjoy luxurious amenities and convenient living at 1131 Courtney Trace Drive, Brandon, FL 33511.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "for-rent-near-me-leash-free-bark-park-griffin",
      "search_query": "Apartments For Rent Near Me with Leash-Free Bark Park",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Leash-Free Bark Park",
      "h2_subtitle": "Discover pet-friendly living at The Griffin in Brandon, FL. Our community features a leash-free bark park and a variety of top-notch amenities.",
      "page_copy": "Looking for apartments for rent near me with a leash-free bark park? The Griffin in Brandon, FL offers a pet-friendly living experience with community amenities like a leash-free bark park, two resort-inspired pools, and two fitness centers. Our community also features a clubhouse with a resident lounge, outdoor community grilling areas, and a 24-hour concierge package system. Located at 1131 Courtney Trace Drive, The Griffin provides convenient living with valet trash services, garages available, and concierge cleaning services. Choose from our one, two, or three-bedroom floor plans and enjoy the best of Brandon, FL.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
      "blank_image_media": {
        "alt_text": "Community pool area with lounge chairs and umbrellas.",
        "public_id": "019f6c12-a13e-7597-a3cd-542b79a75f5d",
        "storage_key": "property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Griffin | For Rent Near Me with Leash-Free Bark Park",
      "seo_description": "Find apartments for rent near me with a leash-free bark park at The Griffin. Enjoy pet-friendly amenities and convenient living at 1131 Courtney Trace Drive, Brandon, FL 33511.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "for-rent-near-me-community-conference-rooms-griffin",
      "search_query": "Apartments For Rent Near Me with Conference Rooms",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Conference Rooms",
      "h2_subtitle": "Experience professional living at The Griffin in Brandon, FL. Our community features community conference rooms and a variety of top-notch amenities.",
      "page_copy": "Searching for apartments for rent near me with community conference rooms? The Griffin in Brandon, FL offers a professional living experience with community amenities like community conference rooms, two resort-inspired pools, and two fitness centers. Our community also features a clubhouse with a resident lounge, a leash-free bark park, and outdoor community grilling areas. Located at 1131 Courtney Trace Drive, The Griffin provides convenient living with valet trash services, garages available, and concierge cleaning services. Choose from our one, two, or three-bedroom floor plans and enjoy the best of Brandon, FL.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
      "blank_image_media": {
        "alt_text": "Community pool area with lounge chairs and umbrellas.",
        "public_id": "019f6c12-a13e-7597-a3cd-542b79a75f5d",
        "storage_key": "property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Griffin | For Rent Near Me with Community Conference Rooms",
      "seo_description": "Find apartments for rent near me with community conference rooms at The Griffin. Enjoy professional amenities and convenient living at 1131 Courtney Trace Drive, Brandon, FL 33511.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "for-rent-near-me-generous-closet-space-griffin",
      "search_query": "Apartments For Rent with Generous Closet Space",
      "category": "Amenity",
      "h1_title": "Apartments For Rent with Generous Closet Space",
      "h2_subtitle": "Discover spacious living at The Griffin in Brandon, FL. Our apartments feature generous closet space and a variety of modern amenities.",
      "page_copy": "Looking for apartments for rent near me with generous closet space? The Griffin in Brandon, FL offers spacious living with apartment features like generous closet space, premium black or stainless steel appliances, and sleek granite or quartz countertops. Each unit includes in-home washer and dryer, screened-in private patios or balconies, and modern lighting and plumbing fixtures. Located at 1131 Courtney Trace Drive, The Griffin provides convenient living with smart home features, wood-style flooring, and decorative tile backsplashes. Choose from our one, two, or three-bedroom floor plans and enjoy the best of Brandon, FL.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
      "blank_image_media": {
        "alt_text": "Community pool area with lounge chairs and umbrellas.",
        "public_id": "019f6c12-a13e-7597-a3cd-542b79a75f5d",
        "storage_key": "property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Griffin | Apartments For Rent with Generous Closet Space",
      "seo_description": "Find apartments for rent near me with generous closet space at The Griffin. Enjoy spacious living and modern amenities at 1131 Courtney Trace Drive, Brandon, FL 33511.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "for-rent-near-me-with-storage-at-the-griffin",
      "search_query": "Apartments For Rent with Storage",
      "category": "Amenity",
      "h1_title": "Apartments For Rent with Storage at The Griffin",
      "h2_subtitle": "Enjoy convenient living at The Griffin in Brandon, FL. Our apartments feature additional storage options and a variety of modern amenities.",
      "page_copy": "Searching for apartments for rent near me with storage? The Griffin in Brandon, FL offers convenient living with apartment features like additional storage options, premium black or stainless steel appliances, and sleek granite or quartz countertops. Each unit includes in-home washer and dryer, screened-in private patios or balconies, and modern lighting and plumbing fixtures. Located at 1131 Courtney Trace Drive, The Griffin provides spacious living with smart home features, wood-style flooring, and decorative tile backsplashes. Choose from our one, two, or three-bedroom floor plans and enjoy the best of Brandon, FL.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
      "blank_image_media": {
        "alt_text": "Community pool area with lounge chairs and umbrellas.",
        "public_id": "019f6c12-a13e-7597-a3cd-542b79a75f5d",
        "storage_key": "property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Griffin | Apartments For Rent with Storage",
      "seo_description": "Find apartments for rent near me with storage at The Griffin. Enjoy convenient living and modern amenities at 1131 Courtney Trace Drive, Brandon, FL 33511.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "for-rent-near-me-premium-appliances-the-griffin",
      "search_query": "Apartments For Rent Near Me with Stainless Steel Appliances",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Stainless Steel Appliances",
      "h2_subtitle": "Experience modern living at The Griffin in Brandon, FL. Our apartments feature premium black or stainless steel appliances and a variety of upscale amenities.",
      "page_copy": "Looking for apartments for rent near me with premium black or stainless steel appliances? The Griffin in Brandon, FL offers modern living with apartment features like premium black or stainless steel appliances, sleek granite or quartz countertops, and generous closet space. Each unit includes in-home washer and dryer, screened-in private patios or balconies, and modern lighting and plumbing fixtures. Located at 1131 Courtney Trace Drive, The Griffin provides convenient living with smart home features, wood-style flooring, and decorative tile backsplashes. Choose from our one, two, or three-bedroom floor plans and enjoy the best of Brandon, FL.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
      "blank_image_media": {
        "alt_text": "Community pool area with lounge chairs and umbrellas.",
        "public_id": "019f6c12-a13e-7597-a3cd-542b79a75f5d",
        "storage_key": "property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Griffin | Apartments For Rent Near Me with Stainless Steel Appliances",
      "seo_description": "Find apartments for rent near me with premium black or stainless steel appliances at The Griffin. Enjoy modern living and upscale amenities at 1131 Courtney Trace Drive, Brandon, FL 33511.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "for-rent-near-me-granite-quartz-countertops-griffin",
      "search_query": "Apartments For Rent Near Me with Granite or Quartz Countertops",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Granite or Quartz Countertops at The Griffin",
      "h2_subtitle": "Discover upscale living at The Griffin in Brandon, FL. Our apartments feature sleek granite or quartz countertops and a variety of modern amenities.",
      "page_copy": "Searching for apartments for rent near me with sleek granite or quartz countertops? The Griffin in Brandon, FL offers upscale living with apartment features like sleek granite or quartz countertops, premium black or stainless steel appliances, and generous closet space. Each unit includes in-home washer and dryer, screened-in private patios or balconies, and modern lighting and plumbing fixtures. Located at 1131 Courtney Trace Drive, The Griffin provides convenient living with smart home features, wood-style flooring, and decorative tile backsplashes. Choose from our one, two, or three-bedroom floor plans and enjoy the best of Brandon, FL.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
      "blank_image_media": {
        "alt_text": "Community pool area with lounge chairs and umbrellas.",
        "public_id": "019f6c12-a13e-7597-a3cd-542b79a75f5d",
        "storage_key": "property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Griffin | Apartments For Rent Near Me with Granite or Quartz Countertops",
      "seo_description": "Find apartments for rent near me with sleek granite or quartz countertops at The Griffin. Enjoy upscale living and modern amenities at 1131 Courtney Trace Drive, Brandon, FL 33511.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "for-rent-near-me-wood-style-flooring-the-griffin",
      "search_query": "Apartments For Rent Near Me with Wood Flooring",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Wood Flooring",
      "h2_subtitle": "Experience elegant living at The Griffin in Brandon, FL. Our apartments feature wood-style flooring* and a variety of modern amenities.",
      "page_copy": "Looking for apartments for rent near me with wood-style flooring*? The Griffin in Brandon, FL offers elegant living with apartment features like wood-style flooring*, premium black or stainless steel appliances, and sleek granite or quartz countertops. Each unit includes in-home washer and dryer, screened-in private patios or balconies, and modern lighting and plumbing fixtures. Located at 1131 Courtney Trace Drive, The Griffin provides convenient living with smart home features, generous closet space, and decorative tile backsplashes. Choose from our one, two, or three-bedroom floor plans and enjoy the best of Brandon, FL.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
      "blank_image_media": {
        "alt_text": "Community pool area with lounge chairs and umbrellas.",
        "public_id": "019f6c12-a13e-7597-a3cd-542b79a75f5d",
        "storage_key": "property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Griffin | Apartments For Rent Near Me with Wood Flooring",
      "seo_description": "Find apartments for rent near me with wood-style flooring at The Griffin. Enjoy elegant living and modern amenities at 1131 Courtney Trace Drive, Brandon, FL 33511.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "for-rent-brandon-fl-near-university-south-florida",
      "search_query": "Apartments For Rent In Brandon FL Near University of South Florida",
      "category": "POI",
      "h1_title": "Apartments For Rent In Brandon FL Near University of South Florida at The Griffin",
      "h2_subtitle": "Experience convenient living at The Griffin in Brandon, FL. Our apartments are located near the University of South Florida and feature a variety of modern amenities.",
      "page_copy": "Looking for apartments for rent in Brandon FL near the University of South Florida? The Griffin offers convenient living with easy access to the University of South Florida, making it an ideal choice for students and faculty. Our community features two resort-inspired pools, two fitness centers, and a clubhouse with a resident lounge. Each apartment includes premium black or stainless steel appliances, sleek granite or quartz countertops, and in-home washer and dryer. Located at 1131 Courtney Trace Drive, The Griffin provides spacious living with smart home features, generous closet space, and decorative tile backsplashes. Choose from our one, two, or three-bedroom floor plans and enjoy the best of Brandon, FL.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
      "blank_image_media": {
        "alt_text": "Community pool area with lounge chairs and umbrellas.",
        "public_id": "019f6c12-a13e-7597-a3cd-542b79a75f5d",
        "storage_key": "property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Griffin | Apartments For Rent In Brandon FL Near the University of South Florida",
      "seo_description": "Find apartments for rent in Brandon FL near the University of South Florida at The Griffin. Enjoy convenient living and modern amenities at 1131 Courtney Trace Drive, Brandon, FL 33511.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "for-rent-in-brandon-fl-near-university-of-tampa",
      "search_query": "Apartments For Rent In Brandon FL Near The University of Tampa",
      "category": "POI",
      "h1_title": "Apartments For Rent In Brandon FL Near The University of Tampa ",
      "h2_subtitle": "Discover convenient living at The Griffin in Brandon, FL. Our apartments are located near The University of Tampa and feature a variety of modern amenities.",
      "page_copy": "Looking for apartments for rent in Brandon FL near The University of Tampa? The Griffin offers convenient living with easy access to The University of Tampa, making it an ideal choice for students and faculty. Our community features two resort-inspired pools, two fitness centers, and a clubhouse with a resident lounge. Each apartment includes premium black or stainless steel appliances, sleek granite or quartz countertops, and in-home washer and dryer. Located at 1131 Courtney Trace Drive, The Griffin provides spacious living with smart home features, generous closet space, and decorative tile backsplashes. Choose from our one, two, or three-bedroom floor plans and enjoy the best of Brandon, FL.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
      "blank_image_media": {
        "alt_text": "Community pool area with lounge chairs and umbrellas.",
        "public_id": "019f6c12-a13e-7597-a3cd-542b79a75f5d",
        "storage_key": "property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Griffin | Apartments For Rent In Brandon FL Near The University of Tampa",
      "seo_description": "Find homes for rent in Brandon FL near The University of Tampa at The Griffin. Enjoy convenient living and modern amenities at 1131 Courtney Trace Drive, Brandon, FL 33511.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "for-rent-in-brandon-fl-near-erwin-technical-college",
      "search_query": "Apartments For Rent In Brandon FL Near Erwin Technical College",
      "category": "POI",
      "h1_title": "Apartments For Rent In Brandon FL Near Erwin Technical College at The Griffin",
      "h2_subtitle": "Discover convenient living at The Griffin in Brandon, FL. Our apartments are located near Erwin Technical College and feature a variety of modern amenities.",
      "page_copy": "Looking for apartments for rent in Brandon FL near Erwin Technical College? The Griffin offers convenient living with easy access to Erwin Technical College, making it an ideal choice for students and faculty. Our community features two resort-inspired pools, two fitness centers, and a clubhouse with a resident lounge. Each apartment includes premium black or stainless steel appliances, sleek granite or quartz countertops, and in-home washer and dryer. Located at 1131 Courtney Trace Drive, The Griffin provides spacious living with smart home features, generous closet space, and decorative tile backsplashes. Choose from our one, two, or three-bedroom floor plans and enjoy the best of Brandon, FL.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
      "blank_image_media": {
        "alt_text": "Community pool area with lounge chairs and umbrellas.",
        "public_id": "019f6c12-a13e-7597-a3cd-542b79a75f5d",
        "storage_key": "property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Griffin | Apartments For Rent In Brandon FL Near Erwin Technical College",
      "seo_description": "Find apartments for rent in Brandon FL near Erwin Technical College at The Griffin. Enjoy convenient living and modern amenities at 1131 Courtney Trace Drive, Brandon, FL 33511.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "for-rent-in-brandon-fl-near-art-institute-tampa",
      "search_query": "Apartments For Rent In Brandon FL Near The Art Institute of Tampa",
      "category": "POI",
      "h1_title": "Apartments For Rent In Brandon FL Near The Art Institute of Tampa at The Griffin",
      "h2_subtitle": "Experience convenient living at The Griffin in Brandon, FL. Our apartments are located near The Art Institute of Tampa and feature a variety of modern amenities.",
      "page_copy": "Looking for apartments for rent in Brandon FL near The Art Institute of Tampa? The Griffin offers convenient living with easy access to The Art Institute of Tampa, making it an ideal choice for students and faculty. Our community features two resort-inspired pools, two fitness centers, and a clubhouse with a resident lounge. Each apartment includes premium black or stainless steel appliances, sleek granite or quartz countertops, and in-home washer and dryer. Located at 1131 Courtney Trace Drive, The Griffin provides spacious living with smart home features, generous closet space, and decorative tile backsplashes. Choose from our one, two, or three-bedroom floor plans and enjoy the best of Brandon, FL.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
      "blank_image_media": {
        "alt_text": "Community pool area with lounge chairs and umbrellas.",
        "public_id": "019f6c12-a13e-7597-a3cd-542b79a75f5d",
        "storage_key": "property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Griffin | Apartments For Rent In Brandon FL Near The Art Institute of Tampa",
      "seo_description": "Find apartments for rent in Brandon FL near The Art Institute of Tampa at The Griffin. Enjoy convenient living and modern amenities at 1131 Courtney Trace Drive, Brandon, FL 33511.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "for-rent-in-brandon-fl-near-seffner-christian-academy",
      "search_query": "Homes For Rent In Brandon FL Near Seffner Christian Academy",
      "category": "POI",
      "h1_title": "Homes For Rent In Brandon FL Near Seffner Christian Academy at The Griffin",
      "h2_subtitle": "Discover convenient living at The Griffin in Brandon, FL. Our apartments are located near Seffner Christian Academy and feature a variety of modern amenities.",
      "page_copy": "Looking for apartments for rent in Brandon FL near Seffner Christian Academy? The Griffin offers convenient living with easy access to Seffner Christian Academy, making it an ideal choice for families seeking a quality, Biblically based education for their children. Our community features two resort-inspired pools, two fitness centers, and a clubhouse with a resident lounge. Each apartment includes premium black or stainless steel appliances, sleek granite or quartz countertops, and in-home washer and dryer. Located at 1131 Courtney Trace Drive, The Griffin provides spacious living with smart home features, generous closet space, and decorative tile backsplashes. Choose from our one, two, or three-bedroom floor plans and enjoy the best of Brandon, FL.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
      "blank_image_media": {
        "alt_text": "Community pool area with lounge chairs and umbrellas.",
        "public_id": "019f6c12-a13e-7597-a3cd-542b79a75f5d",
        "storage_key": "property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Griffin | Homes For Rent In Brandon FL Near Seffner Christian Academy",
      "seo_description": "Find apartments for rent in Brandon FL near Seffner Christian Academy at The Griffin. Enjoy convenient living and modern amenities at 1131 Courtney Trace Drive, Brandon, FL 33511.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "for-rent-in-brandon-fl-near-universal-academy",
      "search_query": "Homes For Rent In Brandon FL Near Universal Academy of Florida",
      "category": "POI",
      "h1_title": "Homes For Rent In Brandon FL Near Universal Academy of Florida",
      "h2_subtitle": "Experience convenient living at The Griffin in Brandon, FL. Our apartments are located near Universal Academy of Florida (UAF) and feature a variety of modern amenities.",
      "page_copy": "Looking for apartments for rent in Brandon FL near Universal Academy of Florida (UAF)? The Griffin offers convenient living with easy access to Universal Academy of Florida, a top private daycare-K12 Islamic school in Tampa, FL. Our community features two resort-inspired pools, two fitness centers, and a clubhouse with a resident lounge. Each apartment includes premium black or stainless steel appliances, sleek granite or quartz countertops, and in-home washer and dryer. Located at 1131 Courtney Trace Drive, The Griffin provides spacious living with smart home features, generous closet space, and decorative tile backsplashes. Choose from our one, two, or three-bedroom floor plans and enjoy the best of Brandon, FL.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
      "blank_image_media": {
        "alt_text": "Community pool area with lounge chairs and umbrellas.",
        "public_id": "019f6c12-a13e-7597-a3cd-542b79a75f5d",
        "storage_key": "property/6767906449163357/019f6c12-a13e-7597-a3cd-542b79a75f5d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Griffin | Homes For Rent In Brandon FL Near Universal Academy of Florida",
      "seo_description": "Find apartments for rent in Brandon FL near Universal Academy of Florida (UAF) at The Griffin. Enjoy convenient living and modern amenities at 1131 Courtney Trace Drive, Brandon, FL 33511.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "1-bedroom-apartments-for-rent-in-brandon",
      "search_query": "1 Bedroom Apartments For Rent In Brandon",
      "category": "",
      "h1_title": "Discover Pet-Friendly 1-BR Homes at The Griffin | Brandon, FL Apartments",
      "h2_subtitle": "Discover the perfect blend of comfort and convenience at The Griffin, where our pet-friendly 1 bedroom apartments for rent on 1131 Courtney Trace Drive are the crown jewel of Brandon, FL - tailored amenities and a community vibe await you! Explore your new home today and see why living at The Griffin is a step above the rest.",
      "page_copy": "Nestled in the heart of Brandon, The Griffin invites you to discover the epitome of comfort and convenience in our 1 bedroom apartments for rent. Located at 1131 Courtney Trace Drive, Brandon, Florida 33511, our prestigious address is synonymous with thoughtful amenities and a welcoming atmosphere. Whether you're a professional seeking a tranquil retreat or a couple embarking on a new chapter, our impeccably designed homes cater to those in search of a harmonious balance between work and leisure.<br><br>At The Griffin, our pet-friendly community doesn't just welcome you and your furry friends; it sets the stage for a lifestyle of ease and luxury. Our spacious 1 bedroom apartments in Brandon, FL, are meticulously crafted with your needs in mind, ensuring that each home is a serene haven where you can unwind after a long day. The contemporary architecture, coupled with high-end finishes and state-of-the-art appliances, provides the perfect blend of sophistication and comfort.<br><br>Embrace the laid-back charm and warmth of Brandon while indulging in the amenities that The Griffin has to offer. Picture yourself preparing gourmet meals in your stylish kitchen, or lounging by our crystal-clear swimming pool on a sunny Florida day. Our community is designed to enhance your living experience, providing you with the opportunity to live the life you've always dreamt of.<br><br>For those seeking unparalleled living in Brandon, look no further than The Griffin. Each 1 bedroom apartment is a testament to our commitment to quality, delivering an abode that is not just an apartment, but a home. With our prime location and a myriad of amenities, The Griffin stands out as the ideal choice for renters searching for their perfect 1 bedroom sanctuary in vibrant Brandon. Experience the difference today and make The Griffin the foundation of your new beginning.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with a paved walkway and green trees.",
        "public_id": "019f6c12-a1ca-715a-8af9-7555afe81a64",
        "storage_key": "property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "2-bedroom-apartments-for-rent-in-brandon",
      "search_query": "2 Bedroom Apartments For Rent In Brandon",
      "category": "",
      "h1_title": "Discover Luxury Living at The Griffin: Pet-Friendly 2 Bedroom Apartments for Rent in Brandon, FL!",
      "h2_subtitle": "Discover the perfect blend of comfort and convenience at The Griffin, where our spacious 2 bedroom apartments for rent await you in the heart of Brandon at 1131 Courtney Trace Drive - your ideal pet-friendly home with exceptional amenities tailored to enrich your Florida living experience.",
      "page_copy": "Discover the epitome of comfort and style at The Griffin, located at 1131 Courtney Trace Drive, in the heart of Brandon, Florida. Our pet-friendly community welcomes you and your furry friends to explore the lavish lifestyle waiting within our 1, 2, and 3 bedroom apartments. Particularly, our 2 bedroom apartments for rent in Brandon are meticulously designed to blend spacious living with modern elegance, creating the perfect haven for small families, roommates, or anyone valuing both luxury and practicality.<br><br>As you search for 2 bedroom apartments for rent in Brandon, let The Griffin top your list with its unparalleled blend of convenience and sophistication. Each residence is crafted with plush interiors and a suite of contemporary amenities that cater to your every need. Picture yourself basking in the sunlight of generous windows, preparing gourmet meals in your stylish kitchen, or unwinding in the tranquility of your spacious living area.<br><br>At The Griffin, we not only offer a place to live but a vibrant community that enhances your lifestyle. Indulge in our exclusive amenities, including a state-of-the-art fitness center, a shimmering swimming pool, and lush, manicured grounds that are a feast for the eyes and soul. Our team is dedicated to ensuring that each day spent at The Griffin is as effortless and enjoyable as the last, making it the ideal choice for discerning individuals seeking the finest 2 bedroom apartments for rent in Brandon.<br><br>Join us at The Griffin, where serenity meets luxury in the charming locale of 1131 Courtney Trace Drive, Brandon, FL 33511. Your new home is more than just an apartment—it's a retreat from the ordinary. Connect with us today to schedule your personal tour, and see why our 2 bedroom apartments in Brandon are in high demand. Embrace the lifestyle you deserve and the comfort you crave; make The Griffin your new sanctuary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with a paved walkway and green trees.",
        "public_id": "019f6c12-a1ca-715a-8af9-7555afe81a64",
        "storage_key": "property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "3-bedroom-apartments-in-brandon",
      "search_query": "3 Bedroom Apartments In Brandon",
      "category": "",
      "h1_title": "Spacious 3-Bedroom Homes at The Griffin – Your Pet-Friendly Retreat in Brandon, FL",
      "h2_subtitle": "Experience the epitome of comfort at The Griffin, where our pet-friendly 3 bedroom apartments in Brandon seamlessly blend with modern amenities for an unparalleled living experience at 1131 Courtney Trace Drive, Brandon, Florida 33511. Discover your new home in our vibrant community and embrace the luxury lifestyle you deserve today!",
      "page_copy": "Discover the perfect blend of comfort and convenience at The Griffin—your destination for premier 3 bedroom apartments in Brandon. Nestled in the heart of sunny Florida, our vibrant apartment community at 1131 Courtney Trace Drive, Brandon, FL 33511, offers spacious and stylish living spaces designed to enrich your lifestyle. With a rich array of amenities and a pet-friendly atmosphere, The Griffin is poised to become your tranquil haven amidst the bustling life of Brandon.<br><br>Step into our expansive three-bedroom apartments in Brandon and experience the epitome of modern living. Each apartment is crafted with an eye for elegance and practicality, ensuring that your home is not only aesthetically pleasing but also fully functional for your everyday needs. The Griffin prides itself on catering to the dynamic lives of our residents, creating a welcoming environment where you can thrive and build lasting memories.<br><br>As you explore the amenities at The Griffin, you'll discover a community thoughtfully laid out to include everything from a sparkling pool for those sunny Florida days to inviting communal spaces where you can socialize and unwind. Whether you're hosting friends for a weekend brunch or indulging in a solo workout at our state-of-the-art fitness center, The Griffin provides an array of facilities to cater to your every mood and occasion, ensuring that your new 3 bedroom apartment in Brandon is more than just a place to live—it's a lifestyle.<br><br>So, if you're searching for a 3 bedroom apartment in Brandon, look no further than The Griffin at 1131 Courtney Trace Drive. Contact us today to discover how you can join our thriving community and experience the best of Brandon living. With The Griffin as your home, you'll be investing in a lifestyle that epitomizes comfort, class, and convenience—all waiting for you just a call or click away. Don't miss this opportunity to elevate your living experience; embrace the charm and quality of life that only The Griffin can offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with a paved walkway and green trees.",
        "public_id": "019f6c12-a1ca-715a-8af9-7555afe81a64",
        "storage_key": "property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "apartments-for-rent-in-brandon-florida",
      "search_query": "Apartments For Rent In Brandon Florida",
      "category": "",
      "h1_title": "Discover The Griffin: Stylish 1-2-3 Bedroom Pet-Friendly Apartments for Rent in Brandon, FL",
      "h2_subtitle": "Discover your dream home at The Griffin, where pet-friendly living meets modern convenience in the heart of Brandon, Florida, offering a selection of elegant 1, 2, and 3 bedroom apartments at 1131 Courtney Trace Drive—all designed with your comfort in mind. Experience our unrivaled amenities and embrace the vibrant community that awaits you today!",
      "page_copy": "Discover your new home at The Griffin, where comfort meets convenience in the heart of Brandon, Florida. Nestled at 1131 Courtney Trace Drive, our pet-friendly apartment community proudly offers a range of 1, 2, and 3 bedroom apartments designed to suit your lifestyle. Whether you're a young professional seeking a stylish one-bedroom or a growing family in need of space, The Griffin’s variety ensures that you’ll find the perfect place to call home. With modern amenities and a welcoming atmosphere, The Griffin stands out amongst the apartments for rent in Brandon, FL, by offering an unrivaled living experience.<br><br>At The Griffin, we've tailored our amenities to enhance your living experience in Brandon. Our apartments are not only spacious and thoughtfully designed but also surrounded by lush landscaping and community spaces that invite relaxation and leisure. Picture yourself enjoying Florida's sunny afternoons by our sparkling pool, or taking your furry friend for a stroll through our pet-friendly grounds. Living in one of the most sought-after apartments for rent in Brandon, Florida means unforgettable memories in a place where every detail is crafted with you in mind.<br><br>Experience the allure of living in Brandon, FL, where The Griffin's prime location brings you closer to both work and play. Our address at 1131 Courtney Trace Drive situates you minutes away from top-notch dining, shopping, and entertainment options, while also offering an easy commute to Tampa. Embrace a lifestyle where convenience is woven into the fabric of your day-to-day life, and where each day feels like a retreat. If you've been searching for an apartment for rent in Brandon, Florida, look no further—The Griffin is the community that promises to make your home an oasis.<br><br>Take the first step towards your new life at The Griffin by scheduling a tour today. We are confident that once you explore our community, you'll understand what makes us the premier choice for those seeking apartments for rent in Brandon, Florida. With a balance of luxury, location, and community, The Griffin is not just where you'll live, but where you'll thrive. Join us and start your journey at 1131 Courtney Trace Drive, where Brandon’s best is waiting for you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with a paved walkway and green trees.",
        "public_id": "019f6c12-a1ca-715a-8af9-7555afe81a64",
        "storage_key": "property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-tampa",
      "search_query": "Apartments For Rent Near Tampa",
      "category": "",
      "h1_title": "Luxurious Living at The Griffin: Pet-Friendly 1-3 BR Rentals in Brandon, FL – Minutes from Tampa!",
      "h2_subtitle": "Find your dream home nestled near the heart of the Gulf Coast at The Griffin, where our pet-friendly one, two, and three-bedroom apartments at 1131 Courtney Trace Drive, Brandon, await just a stone's throw from vibrant Tampa. Delve into a life of comfort and convenience, and discover the ample amenities that make our community the perfect retreat to call your own!",
      "page_copy": "Nestled in the heart of Brandon and just a stone's throw away from the vibrant city of Tampa, The Griffin invites you to discover a unique blend of comfort and convenience in our pet-friendly apartment community. Our 1, 2, and 3 bedroom apartments for rent are thoughtfully designed with your lifestyle in mind, boasting spacious layouts and modern amenities that cater to your every need. Whether you're a young professional seeking a cozy retreat or a family in search of ample living space, The Griffin at 1131 Courtney Trace Drive is where your search ends and your new chapter begins.<br><br>Experience a living space that has been crafted with attention to detail and your ultimate satisfaction in mind. Each apartment at The Griffin reflects the serene Floridian charm with a contemporary twist, ensuring that your home is not just a place to stay, but a sanctuary to thrive in. As you explore the Tampa area, you'll find that our proximity to top-tier shopping, dining, and entertainment options is unmatched, providing an ideal locale for those who desire a short commute and an even shorter walk back to tranquility.<br><br>The Griffin's extensive amenities set the stage for a lifestyle that's as active or relaxed as you desire. Our pet-friendly policy means your furry companions can enjoy the sunshine with you at our lush outdoor spaces, and you can both cool off afterward in our sparkling swimming pool. Plus, with a fitness center tailored to wellness enthusiasts and a clubhouse perfect for socializing, you'll find everything you need without ever having to leave the comfort of your community.<br><br>Join us at The Griffin and immerse yourself in the warmth of a community that values connectivity and personal space in equal measure. Surrounded by the allure of Brandon and the excitement of nearby Tampa, this is more than just an address on Courtney Trace Drive—it's your new home. Open the door to a life where city convenience and suburban serenity coexist in perfect harmony, and embrace the unmatched living experience that awaits at The Griffin.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with a paved walkway and green trees.",
        "public_id": "019f6c12-a1ca-715a-8af9-7555afe81a64",
        "storage_key": "property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "apartments-for-rent-with-clubhouse-in-brandon",
      "search_query": "Apartments For Rent With Clubhouse In Brandon",
      "category": "",
      "h1_title": "Luxurious Living at The Griffin: Pet-Friendly 1-3 BR Rentals with Clubhouse in Brandon!",
      "h2_subtitle": "Discover a vibrant lifestyle at The Griffin, nestled in the heart of Brandon at 1131 Courtney Trace Drive, where our pet-friendly community welcomes you to a sanctuary of comfort in our 1, 2, and 3 bedroom apartments, complete with a luxurious clubhouse perfect for your social and relaxation needs. Step into your new haven in Florida's charming Brandon, where The Griffin is not just an apartment, but a place to call home.",
      "page_copy": "Welcome to The Griffin, your ultimate destination for luxurious living in Brandon, Florida, where comfort meets convenience. Are you on the quest for stunning apartments for rent with a clubhouse in Brandon? Look no further! Our pet-friendly community located at 1131 Courtney Trace Drive offers a diverse selection of spacious 1, 2, and 3 bedroom apartments that cater to all your needs. Envision coming home to an apartment that not only embraces modern aesthetics but is also a stone's throw from an inviting clubhouse where you can unwind, socialize, and feel truly at home.<br><br>Our clubhouse is more than just an amenity - it's a social hub designed to enhance your daily living. Whether you're planning a get-together, craving some downtime, or need a change of scenery to work from home, The Griffin's clubhouse is the perfect retreat. Equipped with cozy seating arrangements, high-speed Wi-Fi, and entertainment options, it's a vibrant extension of your apartment, sure to become your favorite spot to relax and connect with fellow residents.<br><br>The Griffin's commitment to offering you a top-tier living experience doesn't end there - our community is crafted with a focus on creating harmonious living spaces for you and your furry companions. By choosing one of our apartments, you open the door to an elevated lifestyle where every detail is designed with your comfort in mind. From sleek modern kitchens to serene bedrooms and expansive living areas, our Brandon, FL apartments are carefully curated to become the haven you've always dreamed of.<br><br>Make the move to The Griffin and experience the pinnacle of apartment living in Brandon, where every day is sprinkled with the joy of community, comfort, and luxury. This is your chance to be part of a dynamic community, indulge in unparalleled amenities, and enjoy the convenience of living in a prime location at 1131 Courtney Trace Drive. Our doors are open to you — experience the blend of style and warmth that make our apartments more than a place to live; they're a place to thrive.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with a paved walkway and green trees.",
        "public_id": "019f6c12-a1ca-715a-8af9-7555afe81a64",
        "storage_key": "property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "apartments-for-rent-with-fitness-center-in-brandon",
      "search_query": "Apartments For Rent With Fitness Center In Brandon",
      "category": "",
      "h1_title": "Discover The Griffin: Spacious 1-3 BR Brandon Apartments with Premier Fitness Center & Pet-Friendly Living",
      "h2_subtitle": "Discover your perfect blend of comfort and convenience at The Griffin, nestled at 1131 Courtney Trace Drive, where our pet-friendly apartments in Brandon, FL, boast a state-of-the-art fitness center, tailored for active lifestyles, alongside stylish 1, 2, and 3-bedroom living spaces designed with you in mind. Explore The Griffin, where every day is an opportunity to thrive in an exceptional community, centrally located for your convenience and enjoyment.",
      "page_copy": "Discover unparalleled living at The Griffin, your go-to destination for luxury apartments with top-tier fitness facilities in Brandon. Nestled serenely at 1131 Courtney Trace Drive, Brandon, Florida 33511, The Griffin offers an exceptional blend of comfort, style, and wellness-centric amenities. Our pet-friendly community is meticulously designed to cater to your active lifestyle, featuring spacious one, two, and three-bedroom apartments tailored to exceed your expectations. Savor the benefits of refined living in a location that's as convenient as it is tranquil.<br><br>At The Griffin, we understand the importance of a well-balanced life, which is why our state-of-the-art fitness center stands as a cornerstone of our commitment to your health and fitness endeavors. Embrace the convenience of having a fully equipped, 24/7 access gym just steps away from your front door. Our modern facilities cater to all levels of training, allowing residents to maintain their fitness regime with ease, any time of day. With everything from high-end cardio machines to strength-training equipment at your disposal, our fitness center is designed to keep you active and inspired.<br><br>Step inside your future home where elegance meets functionality. Our apartments for rent offer a retreat from the everyday hustle, with open-concept living spaces that are both inviting and versatile. Each residence at The Griffin is thoughtfully crafted with sophistication in mind, encompassing premium finishes and expansive windows that invite natural light and offer picturesque views. Here, the fusion of modern aesthetics and practicality ensures that your home is not just a place to return to, but a sanctuary to thrive in.<br><br>Choosing The Griffin as your new home means indulging in a lifestyle that balances the vibrancy of the Brandon community with the serenity of private living. Engage with neighbors, explore local eateries, or unwind within the tranquil confines of our lushly landscaped grounds. With our commitment to providing an impeccable living experience, The Griffin stands out as the premier choice for those searching for apartments for rent with a fitness center in Brandon. We invite you to witness the allure firsthand – welcome to a life of luxury, wellness, and comfort at The Griffin.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with a paved walkway and green trees.",
        "public_id": "019f6c12-a1ca-715a-8af9-7555afe81a64",
        "storage_key": "property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "apartments-with-24/7-online-resident-services-in-brandon",
      "search_query": "Apartments With 24/7 Online Resident Services In Brandon",
      "category": "",
      "h1_title": "The Griffin Brandon: 24/7 Online Services in Our Pet-Friendly 1-3 Bedroom Homes",
      "h2_subtitle": "Discover unparalleled convenience at The Griffin, located at 1131 Courtney Trace Drive, where our pet-friendly apartments in Brandon, FL cater to your lifestyle with 24/7 online resident services. Take your pick from our selection of 1, 2, or 3 bedroom homes and immerse yourself in amenities that promise comfort and community.",
      "page_copy": "Welcome to The Griffin, your premier destination nestled in the heart of Brandon, Florida, where modern convenience meets sophisticated living. At 1131 Courtney Trace Drive, we understand that accessibility is key, which is why our apartments offer round-the-clock 24/7 online resident services, ensuring you can manage your living experience at any hour, from the comfort of your home. Whether you need to schedule maintenance, pay your rent, or reserve community amenities, our responsive online portal keeps life hassle-free and at your fingertips.<br><br>Each of our pet-friendly 1, 2, and 3 bedroom apartment homes in Brandon is designed with your convenience and style in mind. Experience the ease of living in a community that not only values your time but also seeks to provide an unmatched level of service. At The Griffin, you’ll never feel disconnected as our digital resident services allow you to engage with our management team, keep up to date with community news, and connect with neighbors—all within a secure online environment.<br><br>Immerse yourself in the vibrant lifestyle that The Griffin offers. Beyond our online services, our residents enjoy a suite of amenities, from a state-of-the-art fitness center, perfect for staying active, to luxurious outdoor spaces where you can unwind. Our apartments in Brandon, Florida, are more than just homes; they are a statement of stress-free living where both you and your pets can thrive.<br><br>Discover the epitome of convenience at The Griffin, laden with the charm and ease of southern living coupled with the innovation of modern accommodations. We are eager to welcome you to 1131 Courtney Trace Drive, Brandon, FL 33511—where every service is just a click away, and every resident is treated like family. Embark on this seamless living adventure with us; a community well-versed in providing a high-quality home experience, perfectly blended with the digital ease you deserve.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with a paved walkway and green trees.",
        "public_id": "019f6c12-a1ca-715a-8af9-7555afe81a64",
        "storage_key": "property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "apartments-with-24-hour-package-concierge-brandon",
      "search_query": "Apartments With 24-hour Package Concierge Brandon",
      "category": "",
      "h1_title": "The Griffin: Luxurious 1-3 BR Brandon Apartments with 24-Hour Package Concierge – Pet-Friendly!",
      "h2_subtitle": "Experience unparalleled convenience at The Griffin, your premier destination for pet-friendly living at 1131 Courtney Trace Drive, where 24-hour package concierge service ensures you never miss a delivery in Brandon, Florida's most sought-after 1, 2, and 3-bedroom apartments. Discover our vibrant community and amenities tailored for ultimate comfort and lifestyle excellence today!",
      "page_copy": "Welcome to The Griffin, situated at the heart of convenience and luxury at 1131 Courtney Trace Drive, in the vibrant town of Brandon, Florida, where your comfort and lifestyle needs take center stage. Tailored for the modern dweller, our pet-friendly community offers an exceptional living experience in our spacious 1, 2, and 3 bedroom apartments, designed with both style and functionality in mind. Discover the harmonious blend of homey charm and contemporary living at The Griffin, where each detail has been meticulously crafted with your satisfaction as our top priority.<br><br>In today's fast-paced world, we understand how important it is to have services that fit seamlessly into your busy lifestyle, which is why our apartments come with a 24-hour package concierge in Brandon. At The Griffin, we strive to go beyond the ordinary by ensuring that all your online shopping desires are addressed round-the-clock with our secure and innovative package management system. Imagine the ease and peace of mind this brings, knowing that your valuable parcels are received and stored safely until you're ready to collect them, at any hour of the day or night.<br><br>Step outside the comfort of your home and immerse yourself in The Griffin community, where you can explore a myriad of amenities tailored to enhance your living experience. From the invigorating swimming pool that beckons on hot Florida days to the modern fitness center designed to keep you healthy and energized, we cater to every aspect of your dynamic lifestyle. Our commitment to your satisfaction is evident in every corner of our thoughtfully planned community, crafted to encourage a sense of belonging and camaraderie among residents.<br><br>The Griffin is not just an apartment community; it's a retreat that you'll love calling home. Let our serene environment, comprehensive amenities, and unparalleled service elevate your living experience. The energetic atmosphere of Brandon awaits, with The Griffin as your perfect base to explore, relax, and thrive. Join us and discover the ideal home where convenience meets luxury—with a 24-hour package concierge service that complements your lifestyle with an effortless flair. Secure your sanctuary at The Griffin and let us redefine the art of fine living in Brandon, Florida, for you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with a paved walkway and green trees.",
        "public_id": "019f6c12-a1ca-715a-8af9-7555afe81a64",
        "storage_key": "property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "apartments-with-community-grilling-areas-brandon",
      "search_query": "Apartments With Community Grilling Areas Brandon",
      "category": "",
      "h1_title": "Savor Outdoor Living at The Griffin - Pet-Friendly 1-3 BR Apartments with Grilling Areas in Brandon!",
      "h2_subtitle": "Savor the Florida sunshine and indulge in outdoor feasts at The Griffin, nestled at 1131 Courtney Trace Drive, where our apartments boast community grilling areas perfect for Brandon living. Our pet-friendly residences offer a range of 1, 2, and 3 bedroom layouts, ensuring a perfect fit for every lifestyle.",
      "page_copy": "Discover the perfect blend of comfort and convenience at The Griffin, where our expansive community grilling areas offer a taste of the good life in the heart of Brandon. Nestled at 1131 Courtney Trace Drive, Brandon, Florida 33511, this pet-friendly enclave provides a serene backdrop for your weekend barbecues and social gatherings. Picture yourself savoring the Florida sunshine while flipping burgers and grilling veggies amidst the company of friends and neighbors. It's more than an apartment - it's a community hub that brings together grilling aficionados and food lovers from all walks of life.<br><br>At The Griffin, our 1, 2, and 3 bedroom apartments are thoughtfully designed with your comfort in mind, but it's the amenities like our community grilling areas that truly make our residents feel at home. Imagine returning from a day's work to the mouth-watering aroma of grilled cuisine wafting through the air, inviting you to unwind and connect. Our well-maintained grills are always ready for your steaks, hot dogs, and plant-based options, ensuring your spontaneous dinner plans are always a success.<br><br>Residents of Brandon searching for 'apartments with community grilling areas in Brandon' will find their perfect home at The Griffin. Our welcoming outdoor spaces encourage a lifestyle that's both active and social, with the added delight of sharing meals and making memories. Every delicious meal grilled to perfection is an opportunity to meet new friends, bond with loved ones, and indulge in the simple pleasures of outdoor cooking in a community that values togetherness and relaxation.<br><br>Explore a vibrant lifestyle at The Griffin, where community living rises to a new standard of enjoyment. Our community grilling areas are just the beginning of what makes us stand out in Brandon, Florida. Join us and discover a place where neighbors become friends and apartment living feels like a never-ending outdoor festival. Make the move to The Griffin today, and elevate your living experience in an apartment community that truly understands the joy of home, hearth, and the irresistible charm of grilling under the open sky.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with a paved walkway and green trees.",
        "public_id": "019f6c12-a1ca-715a-8af9-7555afe81a64",
        "storage_key": "property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "apartments-with-conference-rooms-in-brandon",
      "search_query": "Apartments With Conference Rooms In Brandon",
      "category": "",
      "h1_title": "The Griffin: Stylish 1-3 BR Brandon Apartments with Conference Rooms - Pet-Friendly!",
      "h2_subtitle": "Discover the perfect blend of work and play at The Griffin, nestled at 1131 Courtney Trace Drive, where our upscale Brandon apartments boast convenient conference rooms for seamless professional gatherings just steps from your doorstep. Our pet-friendly community invites you to explore a range of 1, 2, and 3 bedroom apartments amidst a suite of amenities designed to elevate your Florida living experience.",
      "page_copy": "Nestled in the heart of Brandon, The Griffin at 1131 Courtney Trace Drive presents an exceptional living experience tailored for those who seek convenience and luxury. Our pet-friendly apartment community proudly offers a range of 1, 2, and 3 bedroom apartments, each designed to cater to your comfort and lifestyle needs. With our prime location in Brandon, Florida 33511, you'll find yourself in a vibrant area, while our apartments serve as your tranquil retreat from the bustling city life.<br><br>For the professionals and entrepreneurs, The Griffin recognizes the importance of having a dedicated space to concentrate and collaborate. That's why our apartments with conference rooms in Brandon offer you the quintessential setting to host your important meetings, brainstorming sessions, or simply a quiet place to focus on your work without interruptions. Our state-of-the-art conference facilities are just one of the perks that set us apart, ensuring that your home supports not only your living needs but your professional aspirations as well.<br><br>Delve into the rich array of amenities at The Griffin where productivity meets relaxation. After your successful meeting in our well-appointed conference room, unwind at our sparkling pool or engage in an invigorating workout in our fully-equipped fitness center. It's the seamless balance of work and play that makes The Griffin in Brandon, FL, not just an apartment community, but a lifestyle haven catered to your well-being and success.<br><br>Invite elegance and efficiency into your life by choosing The Griffin as your new home in Brandon. With apartments that boast modern finishes, the added convenience of a professional meeting space on-site, and a welcoming community atmosphere, The Griffin stands as the epitome of sophisticated living in Brandon. Experience the ultimate in apartment living where every detail is designed with you in mind – because at The Griffin, we're not just building apartments, we're crafting a community where your life flourishes both personally and professionally.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with a paved walkway and green trees.",
        "public_id": "019f6c12-a1ca-715a-8af9-7555afe81a64",
        "storage_key": "property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "apartments-with-garages-for-rent-brandon",
      "search_query": "Apartments With Garages For Rent Brandon",
      "category": "",
      "h1_title": "Luxurious Pet-Friendly Homes at The Griffin - 1-3 BR Apartments with Garages in Brandon",
      "h2_subtitle": "Welcome to The Griffin, where convenience meets luxury in Brandon with our coveted apartments boasting attached garages for rent at 1131 Courtney Trace Drive, Brandon, Florida 33511—perfect for safeguarding your vehicle and enhancing your lifestyle. Dive into our pet-friendly community and discover a variety of spacious 1, 2, and 3 bedroom layouts, curated just for you.",
      "page_copy": "Discover the epitome of convenience and comfort at The Griffin, a premier pet-friendly apartment community nestled in the heart of Brandon. With an array of 1, 2, and 3 bedroom apartments tailored to suit your lifestyle, each home is thoughtfully designed to be both practical and luxurious. For those who prize the functionality of their living space, The Griffin shines as an unbeatable choice for apartments with garages for rent in Brandon, providing that extra layer of privacy, security, and space for your vehicles or additional storage.<br><br>Located at 1131 Courtney Trace Drive, Brandon, Florida 33511, The Griffin places you in the midst of suburban serenity while keeping you close to the vibrant pulse of the city. Our spacious garages are perfect for residents looking to protect their car from the elements or who simply need more room for their hobbies and gear. At The Griffin, we understand that your home extends beyond the four walls of your apartment, which is why our garages are designed to enhance your living experience and bring unparalleled peace of mind.<br><br>Step inside The Griffin and be greeted by a community that puts your needs first. Our amenities are crafted to offer a lifestyle of ease and enjoyment, whether you are unwinding after a long day or entertaining friends over the weekend. As you search for 'apartments with garages for rent in Brandon,' it becomes clear that The Griffin stands out with its harmonious blend of convenience, style, and a welcoming atmosphere that is hard to find elsewhere. <br><br>Choosing The Griffin for your new home means embracing a lifestyle where comfort meets sophistication. Our thoughtfully curated apartments in Brandon, FL, paired with the added benefit of personal garages, create an unparalleled living experience. We invite you to explore our vibrant community today and discover why so many have chosen to call The Griffin their sanctuary within the bustling cityscape of Brandon. Don't just look for an apartment; find a place where you can truly thrive—with all the space and amenities you deserve.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with a paved walkway and green trees.",
        "public_id": "019f6c12-a1ca-715a-8af9-7555afe81a64",
        "storage_key": "property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "apartments-with-sunning-deck-in-brandon",
      "search_query": "Apartments With Sunning Deck In Brandon",
      "category": "",
      "h1_title": "Luxurious Living at The Griffin: Pet-Friendly 1-3BR Apartments with Sunning Deck in Brandon, FL!",
      "h2_subtitle": "Embrace the Florida sunshine at The Griffin, where our serene sunning deck awaits to enhance your relaxation at 1131 Courtney Trace Drive in Brandon, FL – your pet-friendly retreat with an array of 1, 2, and 3 bedroom apartments designed for comfort and style. Discover the bliss of resort-inspired living within the vibrant heart of Brandon and elevate your lifestyle to new heights!",
      "page_copy": "Welcome to The Griffin, Brandon's premier apartment community where relaxation and comfort meet luxury living. Nestled at 1131 Courtney Trace Drive, Brandon, Florida 33511, our pet-friendly community is an oasis designed with you in mind. Picture yourself basking in the Florida sunshine on our exclusive sunning deck, the perfect spot to unwind after a busy day or to soak up the weekend vibes. Our sunning deck is not just an amenity – it’s your personal retreat within the bustling city of Brandon, making The Griffin the ideal choice when searching for apartments with sunning decks in the area.<br><br>For those seeking a harmonious balance between work, life, and leisure, The Griffin's one, two, and three-bedroom apartment homes offer an escape from the mundane. Imagine sipping your morning coffee as gentle rays warm your private haven, with each apartment crafted to maximize natural light and outdoor living. The Griffin is more than just a place to rest your head – it's a community designed for living life to the fullest. Each detail, from the spacious floor plans to the modern finishes, caters to those who appreciate thoughtful design and effortless sophistication.<br><br>Step out from your well-appointed living space and into a world of amenities, where The Griffin stands apart from the rest. Our residents enjoy far more than a picturesque sunning deck; the amenities extend to a fully-equipped fitness center, a shimmering swimming pool, and meticulously landscaped grounds that invite leisurely strolls and outdoor activities. With these and so many more features, our apartments in Brandon, FL, offer an unmatched living experience that we can't wait for you to discover.<br><br>We understand that your home is your sanctuary, and at The Griffin, we take pride in cultivating a community that reflects that belief. Our commitment to excellence is evident in every square inch of our property, with our dedicated team continually striving to provide an unparalleled living experience. So, why wait? Embark on your journey to find the perfect home today, and let The Griffin in Brandon, FL, with its sun-soaked deck and vibrant atmosphere, be your final destination.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with a paved walkway and green trees.",
        "public_id": "019f6c12-a1ca-715a-8af9-7555afe81a64",
        "storage_key": "property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "apartments-with-two-resort-inspired-pools-in-brandon",
      "search_query": "Apartments With Two Resort-inspired Pools In Brandon",
      "category": "",
      "h1_title": "Luxury Living at The Griffin: Discover Pet-Friendly 1-3BR Apartments with Two Pools in Brandon!",
      "h2_subtitle": "Discover a haven of relaxation at The Griffin, where our two resort-inspired pools offer a luxurious escape amidst the sun-drenched charm of Brandon at 1131 Courtney Trace Drive, Florida. Revel in our pet-friendly one, two, and three-bedroom apartments—your quintessential retreat for a serene and stylish living.",
      "page_copy": "Discover the epitome of relaxation and luxury at The Griffin, where elegance meets comfort in the heart of Brandon. Nestled at 1131 Courtney Trace Drive, Brandon, Florida 33511, our pet-friendly apartment community is a haven for those who seek the serenity of resort-style living. Each of our spacious 1, 2, and 3 bedroom apartments is meticulously crafted to embody the perfect blend of style and convenience, making The Griffin the ideal place to call home.<br><br>Experience an oasis of tranquility with not one, but two resort-inspired pools that are the centerpiece of our community. These shimmering aquatic retreats are designed for your ultimate relaxation and socialization. Imagine basking in the Florida sun on the expansive sundeck, taking a refreshing dip on a warm afternoon, or hosting a lively poolside barbecue with friends and family—a daily luxury for The Griffin residents.<br><br>At The Griffin, our commitment to an exceptional living experience extends beyond the walls of your apartment. Dive into the life of leisure with our comprehensive suite of amenities that cater to your every need. Our two resort-inspired pools are just the beginning. Explore the possibilities of an active lifestyle with our state-of-the-art fitness center, entertain in style at our elegant clubhouse, or simply unwind with your furry friend by your side in our welcoming, pet-friendly environment.<br><br>Step into the next chapter of your life with confidence, knowing that The Griffin in Brandon is where your dreams of upscale apartment living become reality. With the allure of our two magnificent pools and the unmatched comfort of our apartment homes, it's no wonder discerning renters view us as the pinnacle of Florida living. Don't miss out on the extraordinary opportunity to indulge in a daily vacation lifestyle—join The Griffin community today, and make every day a staycation.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with a paved walkway and green trees.",
        "public_id": "019f6c12-a1ca-715a-8af9-7555afe81a64",
        "storage_key": "property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "luxury-1-bedroom-apartments-in-brandon",
      "search_query": "Luxury 1 Bedroom Apartments In Brandon",
      "category": "",
      "h1_title": "Discover Elite Comfort at The Griffin: Luxury 1-Bedroom Apartments in Brandon, FL",
      "h2_subtitle": "Discover unparalleled sophistication at The Griffin, where our pet-friendly luxury 1-bedroom apartments in Brandon are a harmonious blend of comfort and elegance, nestled at 1131 Courtney Trace Drive. Immerse yourself in our vibrant community, designed to exceed your expectations with a suite of amenities that cater to every lifestyle.",
      "page_copy": "Step into a world of elegance and comfort with The Griffin, your premier destination for luxury 1 bedroom apartments in Brandon. Our pet-friendly community, nestled at 1131 Courtney Trace Drive, Brandon, Florida 33511, offers an exclusive living experience tailored to those seeking a blend of convenience and sophistication. Each one-bedroom suite is a sanctuary of modern indulgence, where every detail has been carefully curated to enhance your living experience.<br><br>Discover the epitome of luxury living at The Griffin, where our 1 bedroom apartments set the standard for upscale homes in Brandon, FL. Designed for discerning individuals who appreciate attention to detail, these apartments feature state-of-the-art amenities and finishes that exude style and comfort. Indulge in the spacious layouts and take in the serene atmosphere of our community, which has been thoughtfully designed to ensure you feel right at home.<br><br>At The Griffin, we've created an environment that goes beyond the expected, making it the go-to for luxury 1 bedroom apartments in Brandon. Our meticulously landscaped grounds, resort-style amenities, and superior customer service are just the beginning. Your new home is much more than an apartment; it's a retreat from the everyday. The perfect balance of luxury and livability awaits in a location that places the best of Brandon at your doorstep.<br><br>Choosing The Griffin as your new home means opting for a lifestyle of comfort and leisure. Our community not only provides a plush one-bedroom haven but also guarantees a serene and welcoming environment. Experience a sense of belonging as you join our community and create your own unique story within the charming city of Brandon, where your luxury lifestyle is not just an aspiration, but a reality. Welcome home to The Griffin, where your search for the perfect 1 bedroom apartment in Brandon ends, and your journey of upscale living begins.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with a paved walkway and green trees.",
        "public_id": "019f6c12-a1ca-715a-8af9-7555afe81a64",
        "storage_key": "property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "modern-apartments-for-rent-in-brandon",
      "search_query": "Modern Apartments For Rent In Brandon",
      "category": "",
      "h1_title": "Discover The Griffin: Stylish 1-3 BR Modern Apartments for Rent in Brandon, FL – Pet-Friendly & Amenities-Rich!",
      "h2_subtitle": "Discover the pinnacle of stylish living at The Griffin, your destination for modern apartments for rent nestled at 1131 Courtney Trace Drive in vibrant Brandon, Florida. Embrace a lifestyle that blends contemporary design with comfort across our pet-friendly 1, 2, and 3 bedroom residences, complemented by exceptional amenities waiting to enrich your everyday.",
      "page_copy": "Discover the epitome of modern living at The Griffin, your premier destination for sophisticated apartments for rent in Brandon, Florida. Nestled at the desirable address of 1131 Courtney Trace Drive, our pet-friendly community offers a selection of spacious 1, 2, and 3 bedroom apartments meticulously designed to meet the needs of contemporary renters. Each residence boasts modern finishes and thoughtful layouts, positioning The Griffin as a top choice for those seeking a stylish sanctuary in the heart of Brandon.<br><br>Step into The Griffin's apartments and find yourself surrounded by contemporary elegance and comfort. Our carefully crafted units feature state-of-the-art kitchens, generous living spaces, and high-end touches that set a new standard for rental living in Brandon. Whether you're a single professional looking for a sleek one-bedroom or a family seeking a spacious three-bedroom home, The Griffin accommodates lifestyles of all kinds with unparalleled grace and style.<br><br>At The Griffin, we extend the luxury beyond your private abode into a vibrant community, rich with amenities designed to complement your modern lifestyle. From relaxing by the resort-style pool to hosting gatherings in our chic clubhouse or staying active at our well-equipped fitness center, life at The Griffin is about enjoying every moment to the fullest. Your four-legged friends will love it here too, thanks to our pet-friendly policy and well-maintained pet areas.<br><br>Embrace the convenience of living at The Griffin, situated in the heart of Brandon with easy access to premium shopping, dining, and entertainment options. When you choose to make The Griffin your home, you choose a life where style, comfort, and convenience converge. Explore our apartment community today and find out why The Griffin is not just an address, but a destination for those seeking the ultimate in modern apartment living in Brandon. Welcome to your new home, where luxury meets practicality and where your modern lifestyle awaits.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with a paved walkway and green trees.",
        "public_id": "019f6c12-a1ca-715a-8af9-7555afe81a64",
        "storage_key": "property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "oversized-3-bedroom-apartments-in-brandon",
      "search_query": "Oversized 3 Bedroom Apartments In Brandon",
      "category": "",
      "h1_title": "Spacious 3-Bedroom Apartments at The Griffin, Brandon – Perfect Pet-Friendly Homes!",
      "h2_subtitle": "Discover luxurious living at The Griffin, where our oversized 3-bedroom apartments in Brandon provide the perfect blend of comfort and style at 1131 Courtney Trace Drive, welcoming both you and your pets to a world of upscale amenities just waiting to be explored.",
      "page_copy": "Discover the epitome of spacious living at The Griffin, your ultimate destination for oversized 3-bedroom apartments in Brandon. Nestled comfortably at 1131 Courtney Trace Drive, Brandon, Florida 33511, The Griffin beckons you to embrace a lifestyle where comfort and space go hand in hand. Each thoughtfully designed three-bedroom home artfully combines modern aesthetics with functionality, ensuring that your new home isn't just sizable, but also a true sanctuary for you and your loved ones.<br><br>Indulge in the sheer luxury of oversized apartments where every square inch is crafted for your utmost comfort. At The Griffin, our three-bedroom residences are tailored to meet the needs of those who refuse to compromise on space or style. Experience the ease of hosting dinner parties in your expansive living area, or retreat for a peaceful night's rest in your generously proportioned bedrooms. Extra-large closets, vast windows bathing your space in natural light, and an open-concept layout; all work in unison to enhance your living experience in Brandon.<br><br>As a pet-friendly community, The Griffin understands that your pets are an integral part of your family. Our oversized 3-bedroom apartments in Brandon offer ample room for your furry friends to roam and relax by your side. Enjoy the convenience of nearby parks and trails that make for perfect outings with your pets, making The Griffin a haven for all members of your household. <br><br>Embracing the essence of community living, The Griffin's amenities are just as impressive as its apartments. From the invigorating swimming pool to the state-of-the-art fitness center and cozy communal lounges, every aspect of your life is catered to. So why wait? Join us at The Griffin and experience the exceptional life that awaits you in our oversized 3-bedroom apartments in Brandon – because when it comes to your home, size does matter, and so does style.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with a paved walkway and green trees.",
        "public_id": "019f6c12-a1ca-715a-8af9-7555afe81a64",
        "storage_key": "property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-with-leash-free-bark-park-in-brandon",
      "search_query": "Pet-friendly Apartments With Leash-free Bark Park In Brandon",
      "category": "",
      "h1_title": "Discover The Griffin: Deluxe Pet-Friendly Apartments with Leash-Free Bark Park in Brandon, FL",
      "h2_subtitle": "Discover the joy of an invigorating pet-friendly living at The Griffin, where your furry friends can roam and frolic at our leash-free bark park in the heart of Brandon at 1131 Courtney Trace Drive. Embrace the comfort of our spacious 1, 2, and 3 bedroom apartments—an oasis designed for you and your pets to thrive.",
      "page_copy": "Welcome to The Griffin, your ideal destination in Brandon, Florida, for pet-friendly living at its finest! Nestled at 1131 Courtney Trace Drive, our premier apartment community understands the bond between you and your furry friends, which is why we go the extra mile to ensure that every tail wags with joy. Our leash-free bark park is a sprawling, secure haven where your pets can run, play, and socialize without the restrictions of a leash, providing the perfect outdoor retreat for both you and your beloved pets.<br><br>At The Griffin, we believe your search for a pet-friendly apartment with a leash-free bark park in Brandon ends with us. Our one, two, and three-bedroom homes are not only spacious and comfortable but also thoughtfully designed with you and your pets in mind. Each apartment is a blend of style and practicality, creating a warm and inviting space that both you and your pets can call home. The open layouts ensure plenty of room for pet beds, toys, and easy access to the outdoors for daily walks and adventures.<br><br>But The Griffin is more than just an apartment community; it's a lifestyle. We prideously promote an active and social lifestyle for our residents and their pets. Stroll through our beautifully landscaped grounds with your canine companion, or indulge in playtime at our leash-free bark park, designed to offer your pets the freedom they desire. It's the perfect spot to meet and mingle with other pet-loving neighbors, reinforcing the sense of community that The Griffin is known for.<br><br>We invite you to explore all the amenities and comfort that come with living at The Griffin. Situated in the heart of Brandon, Florida, our apartments deliver the ultimate pet-friendly atmosphere coupled with the convenience of being close to all that the area has to offer, from shops to cafes and parks. Make The Griffin your new home, where both you and your pets can thrive in an environment that caters to your needs. Contact us today to schedule a visit and experience firsthand why our pet-friendly apartments with a leash-free bark park are exactly what you've been looking for!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with a paved walkway and green trees.",
        "public_id": "019f6c12-a1ca-715a-8af9-7555afe81a64",
        "storage_key": "property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449163357",
      "source": "custom",
      "page_item_url": "spacious-2-bedroom-apartments-for-rent-brandon",
      "search_query": "Spacious 2 Bedroom Apartments For Rent Brandon",
      "category": "",
      "h1_title": "Discover Luxurious Living at The Griffin: Spacious 2 Bedroom Apartments for Rent in Brandon, FL",
      "h2_subtitle": "Discover the epitome of spacious comfort at The Griffin, nestled at 1131 Courtney Trace Drive in Brandon, where our pet-friendly community takes pride in presenting an array of 2 bedroom apartments for rent, designed with your lifestyle in mind. Immerse yourself in the heart of Florida living with our premium amenities and welcoming atmosphere today!",
      "page_copy": "Discover the perfect blend of comfort and convenience with The Griffin's spacious 2-bedroom apartments for rent in Brandon. Nestled at 1131 Courtney Trace Drive, Brandon, Florida 33511, these homes are designed to elevate your living experience. With ample room to spread out and relax, our pet-friendly apartments boast modern fixtures and plush interiors that cater to a lifestyle of sophistication and ease. Step into The Griffin and see why our residents love to call it home.<br><br>As you search for your ideal 2-bedroom apartment in Brandon, FL, consider the unmatched living spaces The Griffin offers. Our 2-bedroom floor plans are thoughtfully designed to maximize space and provide a haven of comfort after a long day. Here, each apartment is a backdrop for creating cherished memories, whether you're entertaining guests or enjoying a peaceful afternoon with your family.<br><br>The Griffin is not just a place to live; it's a community that prioritizes your well-being and satisfaction. Our resort-style amenities resonate with the desire for a balanced lifestyle, offering everything from a sparkling swimming pool to a state-of-the-art fitness center. When you choose to reside within our community, you're choosing a lifestyle that aligns with your need for both relaxation and invigoration.<br><br>Imagine yourself residing in a vibrant community that's conveniently located with easy access to shopping, dining, and entertainment options in Brandon. Wake up in your spacious 2-bedroom apartment filled with natural light, prepare a meal in your well-appointed kitchen, and step out onto your private balcony to savor a moment of tranquility. At The Griffin, your search for the perfect apartment in Brandon ends with an address that you'll be proud to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019f6c12-95a7-725b-a5fc-916b038bc85b",
        "storage_key": "property/6767906449163357/019f6c12-95a7-725b-a5fc-916b038bc85b.webp",
        "width": 1024,
        "height": 768
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with a paved walkway and green trees.",
        "public_id": "019f6c12-a1ca-715a-8af9-7555afe81a64",
        "storage_key": "property/6767906449163357/019f6c12-a1ca-715a-8af9-7555afe81a64.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "4284"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "7189306841"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a58\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a58\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5394476"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-K9BWGXLK"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "4"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "22307032624"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "07811f1bff2d2d48"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/rkwn5eogwd2"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/07d17cba-693f-4aac-9e31-b4ca70fd45ac"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "656-240-4519"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkVMN2JaaTBqSmZpOEp0NnozTWRzaXc9PSIsInZhbHVlIjoiSHlhaWR2dzVPNWN6a2tpdVlud1NwUT09IiwibWFjIjoiZTU1MDFjNjliMDcxNTY3OGYzMTgwMmFiY2QzNzhmYzEzYjU0YTBiNGZkYTQwYWNlNTE3OTg3NjNmOWNmMTI2YiJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "4284",
  "custom_repli_id": "7189306841",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a58\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a58\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "5394476",
  "custom_google_gtm_id": "GTM-K9BWGXLK",
  "custom_rollout_phase": "4",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "22307032624",
  "custom_knock_community_id": "07811f1bff2d2d48",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/rkwn5eogwd2",
  "custom_self_guided_tour_url": "https://selftournow.com/property/07d17cba-693f-4aac-9e31-b4ca70fd45ac",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "656-240-4519",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkVMN2JaaTBqSmZpOEp0NnozTWRzaXc9PSIsInZhbHVlIjoiSHlhaWR2dzVPNWN6a2tpdVlud1NwUT09IiwibWFjIjoiZTU1MDFjNjliMDcxNTY3OGYzMTgwMmFiY2QzNzhmYzEzYjU0YTBiNGZkYTQwYWNlNTE3OTg3NjNmOWNmMTI2YiJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "8aac948b-615c-4694-8829-1639644b9fc0",
  "custom_audioeye_site_hash": "3f517cc9df2340c22a41c779936dfc04"
};

export const generatedAt = '2026-11-03T20:24:57.180Z';
